{
  "type": "Topology",
  "arcs": [
    [
      [8067, 2556],
      [4, -113],
      [-82, 0],
      [-2, -182],
      [52, -82]
    ],
    [
      [8039, 2179],
      [-73, -23],
      [-95, 8],
      [-28, 27],
      [-160, -3],
      [-55, 24],
      [-43, -20]
    ],
    [
      [7585, 2192],
      [-4, 36],
      [22, 127],
      [22, 75],
      [36, 63],
      [1, 74],
      [-31, 90],
      [14, 34],
      [-36, 141]
    ],
    [
      [7609, 2832],
      [41, 14],
      [117, -1],
      [21, -77],
      [24, -48],
      [62, 5],
      [15, 47],
      [91, -7],
      [9, -59],
      [-3, -69],
      [13, -21],
      [-2, -69],
      [70, 9]
    ],
    [
      [7603, 2850],
      [-10, 43]
    ],
    [
      [7593, 2893],
      [42, 15]
    ],
    [
      [7635, 2908],
      [-32, -58]
    ],
    [
      [7953, 5518],
      [-35, -70]
    ],
    [
      [7918, 5448],
      [-29, 36],
      [-1, 93]
    ],
    [
      [7888, 5577],
      [27, 41]
    ],
    [
      [7915, 5618],
      [21, -42]
    ],
    [
      [7936, 5576],
      [17, -58]
    ],
    [
      [9162, 4568],
      [96, -7],
      [81, 111]
    ],
    [
      [9339, 4672],
      [8, -19]
    ],
    [
      [9347, 4653],
      [5, -46]
    ],
    [
      [9352, 4607],
      [-23, -37],
      [-24, -89]
    ],
    [
      [9305, 4481],
      [-8, -12],
      [-119, 28],
      [-16, 71]
    ],
    [
      [4472, 41],
      [-66, 1],
      [-1, 128]
    ],
    [
      [4405, 170],
      [67, -129]
    ],
    [
      [4641, 1908],
      [73, -92],
      [32, -9],
      [90, -65],
      [5, -25],
      [-39, -87],
      [84, -25],
      [31, 10],
      [37, 43],
      [6, 51]
    ],
    [
      [4960, 1709],
      [39, -22],
      [0, -46],
      [-61, -55],
      [-97, -133]
    ],
    [
      [4841, 1453],
      [-20, -105],
      [-11, -107]
    ],
    [
      [4810, 1241],
      [-3, -29],
      [50, -49],
      [-5, -40],
      [23, -53],
      [-38, -73],
      [-59, -31],
      [-123, -6],
      [7, -106],
      [-63, -28],
      [-54, 6],
      [29, -104],
      [-32, -35],
      [-15, -88],
      [-37, 0],
      [-43, -72],
      [77, -54],
      [-14, -51],
      [-46, -33],
      [-26, -67],
      [-52, -49],
      [22, -90]
    ],
    [
      [4408, 189],
      [-132, 17],
      [-15, 76],
      [-41, 17],
      [-4, 61],
      [31, 25],
      [8, 65],
      [35, 125],
      [-23, 189],
      [29, 191],
      [24, 21],
      [-12, 108],
      [29, 37],
      [-1, 49],
      [23, 55],
      [-29, 162],
      [25, 59],
      [-4, 55],
      [40, 106],
      [28, 35],
      [-5, 137],
      [43, 28],
      [9, 74]
    ],
    [
      [4466, 1881],
      [33, 52],
      [91, -10],
      [51, -15]
    ],
    [
      [8845, 5532],
      [55, 9]
    ],
    [
      [8900, 5541],
      [60, -102],
      [1, -39]
    ],
    [
      [8961, 5400],
      [-14, -2]
    ],
    [
      [8947, 5398],
      [-54, 55]
    ],
    [
      [8893, 5453],
      [-45, 31],
      [-3, 48]
    ],
    [
      [9848, 400],
      [64, -25],
      [-11, -37],
      [-60, -4],
      [7, 66]
    ],
    [
      [12873, 847],
      [39, -19],
      [75, 15],
      [3, -68],
      [-58, -90],
      [-33, 5],
      [-53, 136],
      [27, 21]
    ],
    [
      [12800, 2394],
      [40, -23],
      [32, -47],
      [11, -103],
      [20, -56],
      [9, -68],
      [97, -82],
      [33, -112],
      [42, -3],
      [7, -61],
      [77, -103],
      [10, -114],
      [19, -49],
      [-27, -202],
      [-18, -52],
      [-29, -28],
      [-65, -193],
      [-3, -58],
      [-67, -22],
      [-78, -70],
      [-73, 55],
      [-35, -42],
      [-117, 46],
      [-25, 35],
      [-17, 72],
      [-58, 30],
      [-30, 52],
      [21, 61],
      [-60, -26],
      [-15, -45],
      [-68, 129],
      [-117, 64],
      [-70, -5],
      [-97, -40],
      [-37, 4],
      [-77, -42],
      [-22, -54],
      [-93, 4],
      [-56, -8],
      [-74, -63],
      [-55, 3],
      [-63, 47],
      [20, 41],
      [10, 73],
      [-25, 92],
      [-5, 65],
      [-34, 77],
      [-29, 143],
      [-2, 70],
      [18, 76],
      [32, 71],
      [81, 64],
      [29, -3],
      [135, 61],
      [55, 85],
      [3, 54],
      [27, 49],
      [32, 17],
      [75, 107],
      [54, 24],
      [51, -60],
      [41, 26],
      [49, 107],
      [24, 20],
      [53, 5],
      [39, 18],
      [68, -26],
      [48, 22],
      [18, -28],
      [-60, -135],
      [151, -153],
      [38, -19],
      [26, 19],
      [33, 133],
      [-8, 78],
      [7, 74],
      [33, 99],
      [40, -124],
      [1, -53]
    ],
    [
      [7793, 5935],
      [-31, -73]
    ],
    [
      [7762, 5862],
      [-95, -20]
    ],
    [
      [7667, 5842],
      [-65, 35],
      [-68, -13]
    ],
    [
      [7534, 5864],
      [-34, 36]
    ],
    [
      [7500, 5900],
      [137, 7],
      [22, 71]
    ],
    [
      [7659, 5978],
      [65, 9],
      [68, -26]
    ],
    [
      [7792, 5961],
      [1, -26]
    ],
    [
      [8947, 5398],
      [-54, 55]
    ],
    [
      [9020, 5550],
      [23, 23]
    ],
    [
      [9043, 5573],
      [41, -71],
      [-29, -128]
    ],
    [
      [9055, 5374],
      [-48, 67],
      [-46, -41]
    ],
    [
      [8900, 5541],
      [66, -4],
      [-9, 39]
    ],
    [
      [8957, 5576],
      [63, -26]
    ],
    [
      [8282, 2924],
      [-13, 95]
    ],
    [
      [8269, 3019],
      [57, 24]
    ],
    [
      [8326, 3043],
      [11, -54],
      [-39, -62],
      [-16, -3]
    ],
    [
      [7281, 6114],
      [37, 12],
      [47, -38]
    ],
    [
      [7365, 6088],
      [-5, -39]
    ],
    [
      [7360, 6049],
      [-14, -34]
    ],
    [
      [7346, 6015],
      [-55, 21],
      [-71, 72]
    ],
    [
      [7220, 6108],
      [32, 11]
    ],
    [
      [7252, 6119],
      [29, -5]
    ],
    [
      [7227, 3540],
      [-32, -7]
    ],
    [
      [7195, 3533],
      [-10, 39],
      [2, 132],
      [-36, 76],
      [5, 30]
    ],
    [
      [7156, 3810],
      [50, 54]
    ],
    [
      [7206, 3864],
      [28, 17],
      [30, -33]
    ],
    [
      [7264, 3848],
      [3, -91],
      [-38, -89],
      [-2, -128]
    ],
    [
      [7009, 3733],
      [-27, 15],
      [-33, -17],
      [-42, 43]
    ],
    [
      [6907, 3774],
      [7, 78],
      [32, 47],
      [6, 39],
      [30, 6],
      [60, 70],
      [59, 32],
      [35, -11]
    ],
    [
      [7136, 4035],
      [2, -53],
      [23, -66],
      [46, -12],
      [-1, -40]
    ],
    [
      [7156, 3810],
      [-34, 2]
    ],
    [
      [7122, 3812],
      [-117, -3],
      [4, -76]
    ],
    [
      [10787, 4442],
      [-12, -78]
    ],
    [
      [10775, 4364],
      [-37, 120],
      [-37, 2],
      [-8, -55],
      [-49, 12]
    ],
    [
      [10644, 4443],
      [-38, 140],
      [33, 42],
      [-28, 30],
      [14, 39],
      [50, -27],
      [4, -40],
      [96, -16],
      [-18, -49],
      [30, -120]
    ],
    [
      [8017, 5712],
      [11, -23],
      [104, -8],
      [67, 27],
      [51, -26]
    ],
    [
      [8250, 5682],
      [-34, -65],
      [13, -33]
    ],
    [
      [8229, 5584],
      [-75, -10]
    ],
    [
      [8154, 5574],
      [-36, -34],
      [-28, 20],
      [-61, -14]
    ],
    [
      [8029, 5546],
      [-23, 57]
    ],
    [
      [8006, 5603],
      [24, 51],
      [-13, 58]
    ],
    [
      [7873, 5748],
      [24, -47],
      [-16, -30]
    ],
    [
      [7881, 5671],
      [-26, -50]
    ],
    [
      [7855, 5621],
      [-35, 22],
      [-76, 102],
      [8, 24],
      [121, -21]
    ],
    [
      [8050, 6265],
      [81, 21],
      [38, 77]
    ],
    [
      [8169, 6363],
      [67, 32]
    ],
    [
      [8236, 6395],
      [106, -35],
      [-5, -43],
      [62, -96],
      [-21, -59]
    ],
    [
      [8378, 6162],
      [-100, -42],
      [-186, 30],
      [-40, -18]
    ],
    [
      [8052, 6132],
      [11, 64],
      [-13, 69]
    ],
    [
      [3595, 4200],
      [33, 40]
    ],
    [
      [3628, 4240],
      [-3, -113],
      [-22, -36]
    ],
    [
      [3603, 4091],
      [-8, 109]
    ],
    [
      [4560, 5030],
      [0, 2],
      [1, 0],
      [0, 1]
    ],
    [
      [4561, 5033],
      [2, 0]
    ],
    [
      [4563, 5033],
      [-1, 0]
    ],
    [
      [4562, 5033],
      [-1, 0]
    ],
    [
      [4561, 5033],
      [2, 0]
    ],
    [
      [4563, 5033],
      [0, -1],
      [-6, -6],
      [-1, 0]
    ],
    [
      [4556, 5026],
      [-1, 4]
    ],
    [
      [4555, 5030],
      [0, -3],
      [1, 0],
      [4, 3]
    ],
    [
      [4466, 1881],
      [-28, -8],
      [-37, 143],
      [12, 55],
      [-20, 25],
      [-25, 79]
    ],
    [
      [4368, 2175],
      [25, 63],
      [-17, 47],
      [17, 70],
      [11, 108],
      [-34, 92]
    ],
    [
      [4370, 2555],
      [50, -4],
      [64, 62],
      [52, 10],
      [-2, -103],
      [43, -52],
      [43, -9],
      [59, -50],
      [48, -16],
      [14, -142],
      [76, -2],
      [-1, -55],
      [30, -52],
      [-26, -115]
    ],
    [
      [4820, 2027],
      [-37, 47],
      [-107, -16],
      [-19, -50],
      [-16, -100]
    ],
    [
      [4960, 1709],
      [13, 67],
      [-14, 42],
      [-30, -7],
      [-8, 74],
      [-34, 33],
      [-58, 0],
      [3, 77],
      [-12, 32]
    ],
    [
      [4370, 2555],
      [-40, -4],
      [2, 88],
      [-32, -34],
      [-34, 1],
      [-56, 93],
      [-16, 52],
      [34, 51],
      [9, 78],
      [83, 58],
      [36, -3]
    ],
    [
      [4356, 2935],
      [18, 157],
      [-6, 58],
      [-17, 21],
      [8, 109],
      [77, -2],
      [39, -24]
    ],
    [
      [4475, 3254],
      [22, -31],
      [84, 44],
      [-6, 132],
      [61, 12],
      [73, 30],
      [9, 38]
    ],
    [
      [4718, 3479],
      [48, -71],
      [-18, -69],
      [13, -55],
      [25, -27],
      [99, 33]
    ],
    [
      [4885, 3290],
      [22, 35],
      [57, -12]
    ],
    [
      [4964, 3313],
      [63, -10],
      [51, 116]
    ],
    [
      [5078, 3419],
      [13, 3],
      [32, -132],
      [22, -49],
      [-17, -64],
      [69, -9],
      [148, -76],
      [19, -33],
      [116, -44],
      [59, 2],
      [59, -47],
      [51, -64],
      [64, -19],
      [14, -18],
      [20, -108],
      [-16, -94],
      [-76, -117],
      [-25, -65],
      [-50, -93],
      [3, -107],
      [-15, -126],
      [-20, -98],
      [-40, -75],
      [-7, -59],
      [-41, -60],
      [-43, 1],
      [-62, -22],
      [-72, -43],
      [-47, -46],
      [-34, -56],
      [1, -74],
      [-16, -86],
      [-27, -32],
      [-44, -100],
      [-62, -72],
      [-45, -88]
    ],
    [
      [5009, 1249],
      [7, 60],
      [-23, 39],
      [-126, 111],
      [-26, -6]
    ],
    [
      [11639, 3440],
      [49, 53]
    ],
    [
      [11688, 3493],
      [-4, -65],
      [-45, 12]
    ],
    [
      [10749, 4770],
      [13, -53],
      [-91, -7],
      [-36, 33]
    ],
    [
      [10635, 4743],
      [47, 57],
      [67, -30]
    ],
    [
      [8285, 1917],
      [-55, -42],
      [-36, -42],
      [-58, -110],
      [-57, -10],
      [-36, 23],
      [-68, -84],
      [-28, -6],
      [-5, 56],
      [-34, 62]
    ],
    [
      [7908, 1764],
      [0, 168],
      [39, 2],
      [2, 203],
      [90, 22],
      [15, -24],
      [59, 36]
    ],
    [
      [8113, 2171],
      [8, -5]
    ],
    [
      [8121, 2166],
      [35, -88],
      [45, -63],
      [29, -63],
      [55, -35]
    ],
    [
      [7725, 3606],
      [57, 5],
      [50, 21],
      [44, 68],
      [39, -3],
      [37, 26],
      [28, 63],
      [46, 33]
    ],
    [
      [8026, 3819],
      [26, -61],
      [-6, -46],
      [17, -35]
    ],
    [
      [8063, 3677],
      [30, -24]
    ],
    [
      [8093, 3653],
      [111, -172]
    ],
    [
      [8204, 3481],
      [-117, -7],
      [-80, -62],
      [-58, 17],
      [-57, 40],
      [-37, -47],
      [-4, -40]
    ],
    [
      [7851, 3382],
      [-52, 13],
      [-45, -84]
    ],
    [
      [7754, 3311],
      [-60, 141],
      [2, 86],
      [29, 68]
    ],
    [
      [2235, 5957],
      [-85, 17],
      [-55, 57],
      [-40, 11],
      [-12, 44],
      [103, -27],
      [89, -102]
    ],
    [
      [4900, 6081],
      [12, -63],
      [93, -19],
      [33, -99],
      [-16, -50],
      [-44, 9],
      [-83, 47],
      [-119, -1],
      [2, 53],
      [33, 34],
      [41, 91],
      [48, -2]
    ],
    [
      [3752, 6938],
      [200, -111],
      [-35, -18],
      [-84, 40],
      [-95, -60],
      [-33, 56],
      [47, 93]
    ],
    [
      [3337, 7135],
      [-110, -9],
      [-54, 26],
      [62, 42],
      [102, -59]
    ],
    [
      [4465, 5763],
      [-26, 33],
      [0, 78],
      [-57, 22],
      [-56, -114],
      [-34, -26],
      [-133, 0],
      [-77, -78],
      [-75, -1],
      [-9, -44],
      [-139, -67],
      [-27, 17],
      [40, 91],
      [-17, 101],
      [-41, 28],
      [-51, 61],
      [-138, 81],
      [-49, -17],
      [-81, 8],
      [-138, 49],
      [-218, 0],
      [-253, 0],
      [-235, 0],
      [-121, 0],
      [-269, 0]
    ],
    [
      [2261, 5985],
      [-110, 81],
      [-71, 23],
      [-16, 86],
      [-51, 25],
      [-8, 46],
      [-48, 71]
    ],
    [
      [1957, 6317],
      [21, 63],
      [-68, 37],
      [-65, 106],
      [-83, 79],
      [-79, -51],
      [-63, 63],
      [-77, 18],
      [0, 325],
      [0, 212]
    ],
    [
      [1543, 7169],
      [178, -46],
      [83, 42],
      [58, -7],
      [217, 49],
      [67, -51],
      [170, 19],
      [60, -24],
      [239, -57],
      [16, -40],
      [141, 17],
      [70, 38],
      [80, 8],
      [71, -45],
      [114, -21],
      [119, 8],
      [31, 46],
      [118, -30],
      [18, 58],
      [-88, 58],
      [2, 64],
      [47, 41],
      [93, -34],
      [53, -65],
      [-34, -28],
      [125, -25],
      [48, -37],
      [97, 9],
      [2, 63],
      [114, -12],
      [53, -29],
      [-27, -59],
      [23, -58],
      [-77, -40],
      [-108, -21],
      [-96, -111],
      [-56, -4],
      [-34, -62],
      [-94, -53],
      [-59, -110],
      [-2, -67],
      [59, -9],
      [36, -96],
      [55, 11],
      [73, -25],
      [69, -49],
      [91, -40],
      [108, -8],
      [-7, -51],
      [42, -121],
      [58, -54],
      [31, 19],
      [21, 59],
      [-20, 89],
      [-28, 31],
      [64, 27],
      [66, 79],
      [-30, 87],
      [-48, 43],
      [46, 60],
      [-30, 142],
      [136, -8],
      [33, 15],
      [98, -75],
      [70, -5],
      [12, -120],
      [64, -42],
      [58, 31],
      [64, 90],
      [126, -192],
      [-16, -37],
      [89, -64],
      [88, -34],
      [16, -48],
      [46, -29],
      [3, -65],
      [-57, -41],
      [-65, -20],
      [-50, -47],
      [-67, -9],
      [-84, 12],
      [-101, -4],
      [-33, -41],
      [86, -16],
      [35, -28],
      [-37, -39],
      [26, -105],
      [51, -28],
      [65, 8],
      [19, -35],
      [-88, -34],
      [-83, -64],
      [-70, 90]
    ],
    [
      [2604, 7364],
      [123, -38],
      [141, 45],
      [83, -32],
      [37, -96],
      [138, -56],
      [-57, -72],
      [-139, 24],
      [-121, -23],
      [-170, -14],
      [-111, 36],
      [-131, 137],
      [61, 66],
      [146, 23]
    ],
    [
      [3697, 7367],
      [167, 34],
      [69, -60],
      [109, 2],
      [262, -104],
      [96, -23],
      [72, -77],
      [-73, -26],
      [156, -50],
      [107, -97],
      [-69, -66],
      [-112, 80],
      [-56, -41],
      [112, -74],
      [26, -57],
      [-64, -26],
      [5, -58],
      [-108, 23],
      [-85, 34],
      [-34, 43],
      [-116, 41],
      [-114, -9],
      [-8, 61],
      [143, 29],
      [65, 85],
      [-184, 142],
      [-158, -2],
      [-144, 13],
      [-182, 45],
      [-27, 85],
      [72, 75],
      [73, -22]
    ],
    [
      [3151, 7406],
      [128, -21],
      [16, -104],
      [-65, -22],
      [-164, 71],
      [85, 76]
    ],
    [
      [3434, 7345],
      [-112, 38],
      [60, 40],
      [158, -16],
      [-106, -62]
    ],
    [
      [2356, 7265],
      [-105, -27],
      [-112, 55],
      [79, 104],
      [95, 44],
      [157, -15],
      [81, -41],
      [-147, -55],
      [-48, -65]
    ],
    [
      [3224, 7570],
      [14, -98],
      [-108, 3],
      [-24, 72],
      [118, 23]
    ],
    [
      [2840, 7541],
      [92, -13],
      [-17, -56],
      [-234, -33],
      [-217, 46],
      [91, 72],
      [251, -58],
      [34, 42]
    ],
    [
      [3375, 7592],
      [122, -18],
      [95, -67],
      [112, -7],
      [207, 13],
      [52, -46],
      [-135, -20],
      [-194, -10],
      [-169, 26],
      [-90, 129]
    ],
    [
      [2261, 7536],
      [148, 80],
      [109, -37],
      [-140, -47],
      [-117, 4]
    ],
    [
      [3678, 7739],
      [-80, -79],
      [-151, 4],
      [-152, 103],
      [78, 60],
      [274, -51],
      [31, -37]
    ],
    [
      [4411, 7936],
      [261, -43],
      [-367, -147],
      [-200, -44],
      [33, -28],
      [-172, -76],
      [-32, -59],
      [-353, 17],
      [48, 82],
      [126, 83],
      [-169, 86],
      [-89, 59],
      [486, 71],
      [428, -1]
    ],
    [
      [7534, 5864],
      [-106, -61],
      [-36, 9]
    ],
    [
      [7392, 5812],
      [-32, 43],
      [56, 51]
    ],
    [
      [7416, 5906],
      [84, -6]
    ],
    [
      [4472, 41],
      [-47, -41],
      [-113, 32],
      [-4, 56],
      [33, 65],
      [64, 17]
    ],
    [
      [4408, 189],
      [-89, -34],
      [-7, -53],
      [-61, 17],
      [-46, 40],
      [-49, 32],
      [-1, 70],
      [-20, 38],
      [-5, 98],
      [17, 55],
      [42, 44],
      [-61, 17],
      [38, 50],
      [14, 145],
      [26, 189],
      [18, 38],
      [-14, 121],
      [17, 2],
      [52, 183],
      [16, 86],
      [-9, 86],
      [12, 47],
      [-5, 70],
      [23, 70],
      [7, 111],
      [25, 246],
      [-11, 175]
    ],
    [
      [4337, 2132],
      [31, 43]
    ],
    [
      [11486, 4250],
      [-34, -27],
      [-32, 17],
      [-1, 49],
      [19, 26],
      [66, 15],
      [9, -22],
      [-27, -58]
    ],
    [
      [12240, 6010],
      [47, -41],
      [16, -54],
      [60, 0],
      [99, 40],
      [-75, -191],
      [-48, 10],
      [-34, -20],
      [4, -117],
      [-20, -30]
    ],
    [
      [12289, 5607],
      [-41, 1],
      [-108, -34],
      [-27, -41],
      [-76, -68]
    ],
    [
      [12037, 5465],
      [-84, -43],
      [-30, 34],
      [31, 38],
      [-21, 30],
      [-79, -60],
      [-24, -37],
      [-59, -29],
      [21, -39],
      [65, -52],
      [44, 41],
      [61, -24],
      [6, -30],
      [-56, -16],
      [-77, -99],
      [42, -32],
      [16, -56],
      [51, -96],
      [-26, -59],
      [33, -48],
      [-16, -92],
      [-23, -5],
      [-60, -137],
      [-37, -68],
      [-109, -101],
      [-45, -7],
      [-24, -25],
      [-91, -39],
      [-79, -9],
      [-71, 9]
    ],
    [
      [11396, 4414],
      [-41, 15],
      [-12, 56],
      [-55, 32],
      [-34, -30],
      [-91, -20]
    ],
    [
      [11163, 4467],
      [-40, -59]
    ],
    [
      [11123, 4408],
      [-76, 39],
      [-22, 111],
      [-42, -10],
      [4, 69],
      [38, 47],
      [0, 91],
      [-30, 48],
      [-23, -5]
    ],
    [
      [10972, 4798],
      [-49, 69],
      [-27, -25],
      [-34, 14],
      [-82, -79],
      [-31, -7]
    ],
    [
      [10635, 4743],
      [-28, 33]
    ],
    [
      [10607, 4776],
      [-91, 19],
      [-62, 36],
      [-108, 91],
      [-16, -14]
    ],
    [
      [10330, 4908],
      [-94, 77],
      [-12, 63],
      [19, 97],
      [-43, 67]
    ],
    [
      [10200, 5212],
      [-64, 23],
      [-42, 71]
    ],
    [
      [10094, 5306],
      [-6, 16]
    ],
    [
      [10088, 5322],
      [-5, 55],
      [-37, 7],
      [-10, 53]
    ],
    [
      [10036, 5437],
      [6, 26],
      [65, 39],
      [41, -8],
      [16, 37],
      [50, 6],
      [82, 67]
    ],
    [
      [10296, 5604],
      [24, 48],
      [-36, 99],
      [99, 36],
      [29, 102],
      [78, -19],
      [24, 83],
      [63, 44]
    ],
    [
      [10577, 5997],
      [16, 5]
    ],
    [
      [10593, 6002],
      [43, -71],
      [57, -21],
      [27, -46],
      [-15, -67],
      [14, -25],
      [100, -18],
      [73, -42],
      [41, -86],
      [125, -12],
      [92, -1],
      [58, -34],
      [66, -18],
      [45, 31],
      [124, 22],
      [46, 20],
      [56, 50],
      [-19, 41],
      [21, 36],
      [63, -16],
      [100, 52],
      [57, 54],
      [92, 22],
      [-67, 58],
      [-30, -21],
      [-72, 25],
      [47, 100]
    ],
    [
      [11737, 6035],
      [48, -21],
      [112, 140],
      [11, 74],
      [102, 12],
      [94, -38],
      [67, -174],
      [69, -18]
    ],
    [
      [7008, 3467],
      [-46, 10],
      [-72, -10],
      [-74, -36]
    ],
    [
      [6816, 3431],
      [5, 77],
      [-40, 43],
      [6, 70]
    ],
    [
      [6787, 3621],
      [24, 51],
      [-19, 69],
      [12, 24]
    ],
    [
      [6804, 3765],
      [77, -6],
      [26, 15]
    ],
    [
      [7009, 3733],
      [11, -81],
      [-28, -113],
      [16, -72]
    ],
    [
      [7638, 3311],
      [-71, 0]
    ],
    [
      [7567, 3311],
      [-64, 1]
    ],
    [
      [7503, 3312],
      [5, 45],
      [-33, 48],
      [-18, 49]
    ],
    [
      [7457, 3454],
      [29, 96],
      [35, 34],
      [38, -22],
      [27, 19],
      [18, 76],
      [22, 23],
      [32, 119],
      [33, 44],
      [-9, 52]
    ],
    [
      [7682, 3895],
      [12, 22]
    ],
    [
      [7694, 3917],
      [16, -37],
      [1, -75],
      [22, -53],
      [-52, 3],
      [-8, -27],
      [40, -43],
      [12, -79]
    ],
    [
      [7754, 3311],
      [-3, -31],
      [-63, 29],
      [-50, 2]
    ],
    [
      [8354, 3307],
      [-51, -91],
      [-12, -111]
    ],
    [
      [8291, 3105],
      [-22, -86]
    ],
    [
      [8282, 2924],
      [11, -116],
      [23, -32],
      [21, -72]
    ],
    [
      [8337, 2704],
      [-79, -11],
      [-15, -186],
      [39, -32],
      [-17, -51],
      [-30, 55],
      [-95, 28],
      [-13, 26],
      [-60, 23]
    ],
    [
      [7609, 2832],
      [-6, 18]
    ],
    [
      [7635, 2908],
      [45, 15],
      [18, -26],
      [56, 82],
      [-1, 47],
      [17, 56],
      [44, 57],
      [12, 59],
      [3, 83],
      [22, 101]
    ],
    [
      [8204, 3481],
      [41, -54],
      [52, 18],
      [44, -63]
    ],
    [
      [8341, 3382],
      [13, -75]
    ],
    [
      [7593, 2893],
      [-33, 61]
    ],
    [
      [7560, 2954],
      [30, 31],
      [-15, 38],
      [41, 22],
      [59, -5],
      [17, 65],
      [-23, 79],
      [16, 66],
      [-38, 7],
      [-9, 54]
    ],
    [
      [4139, 3173],
      [-36, 32],
      [-45, -1],
      [-57, 57]
    ],
    [
      [4001, 3261],
      [18, 71],
      [19, 4],
      [32, 66],
      [-17, 98],
      [3, 64],
      [-16, 31]
    ],
    [
      [4040, 3595],
      [25, 40],
      [-4, 42]
    ],
    [
      [4061, 3677],
      [20, -1],
      [46, 45],
      [8, 68],
      [51, 40],
      [30, -5],
      [66, 69],
      [17, -38]
    ],
    [
      [4299, 3855],
      [-25, -9],
      [-37, -67],
      [-16, -74],
      [21, -4],
      [33, -120],
      [73, -1],
      [28, -50],
      [81, 0],
      [-19, -91],
      [20, -68],
      [17, -117]
    ],
    [
      [4356, 2935],
      [-20, 31],
      [13, 59],
      [-29, 27],
      [-90, -3],
      [-23, 60],
      [-58, 69],
      [-10, -5]
    ],
    [
      [3839, 3652],
      [-27, 47],
      [-79, 51],
      [-3, 66]
    ],
    [
      [3730, 3816],
      [81, -9]
    ],
    [
      [3811, 3807],
      [45, -79]
    ],
    [
      [3856, 3728],
      [-17, -76]
    ],
    [
      [3866, 4508],
      [66, -5],
      [53, -40],
      [36, 7],
      [73, -75],
      [36, -11],
      [56, -42],
      [-57, -23],
      [-84, -1],
      [-38, 99],
      [-123, 34],
      [-38, 28],
      [-28, -29],
      [-30, 22],
      [78, 36]
    ],
    [
      [8416, 5192],
      [49, -5]
    ],
    [
      [8465, 5187],
      [-49, 5]
    ],
    [
      [8465, 5187],
      [-49, 5]
    ],
    [
      [7659, 5978],
      [-42, 38],
      [-12, 41],
      [110, 48]
    ],
    [
      [7715, 6105],
      [101, -42],
      [51, -50]
    ],
    [
      [7867, 6013],
      [-75, -52]
    ],
    [
      [7513, 6327],
      [1, -22],
      [166, -49]
    ],
    [
      [7680, 6256],
      [-2, -44],
      [37, -107]
    ],
    [
      [7416, 5906],
      [25, 80],
      [-75, 25]
    ],
    [
      [7366, 6011],
      [-6, 38]
    ],
    [
      [7365, 6088],
      [37, 134],
      [-8, 19]
    ],
    [
      [7394, 6241],
      [75, 31],
      [-11, 54]
    ],
    [
      [7458, 6326],
      [55, 1]
    ],
    [
      [8825, 3908],
      [2, -71]
    ],
    [
      [8827, 3837],
      [-14, -30]
    ],
    [
      [8813, 3807],
      [-40, 7],
      [-4, 33],
      [28, 52]
    ],
    [
      [8797, 3899],
      [28, 9]
    ],
    [
      [7458, 6326],
      [-17, 90],
      [18, 33],
      [68, -13],
      [-14, -109]
    ],
    [
      [4284, 4309],
      [36, 10],
      [62, -33],
      [36, -40],
      [-105, -19],
      [-29, -13]
    ],
    [
      [4284, 4214],
      [0, 95]
    ],
    [
      [7596, 4524],
      [-136, -109],
      [-114, -112],
      [-56, -26]
    ],
    [
      [7290, 4277],
      [-44, -6],
      [0, 37],
      [-186, 177],
      [-134, 126]
    ],
    [
      [6926, 4611],
      [-149, 138]
    ],
    [
      [6777, 4749],
      [1, 15]
    ],
    [
      [6778, 4764],
      [0, 67],
      [64, 43],
      [72, 24],
      [61, 51],
      [2, 42],
      [93, 36],
      [-20, 130],
      [-14, 36]
    ],
    [
      [7036, 5193],
      [143, 83],
      [133, 15],
      [57, 14],
      [85, -10]
    ],
    [
      [7454, 5295],
      [-11, -131],
      [-25, -32],
      [4, -43],
      [57, -71],
      [17, -103]
    ],
    [
      [7496, 4915],
      [15, -77],
      [-6, -140],
      [-15, -24],
      [38, -98],
      [19, 11],
      [49, -63]
    ],
    [
      [3944, 2987],
      [-25, 134],
      [14, 9],
      [20, 95],
      [48, 36]
    ],
    [
      [4139, 3173],
      [-7, -81],
      [-43, -60],
      [-47, -22],
      [-32, -89],
      [-71, 7],
      [5, 59]
    ],
    [
      [8579, 4440],
      [-157, 0],
      [-153, 0],
      [-159, 0]
    ],
    [
      [8110, 4440],
      [0, 211],
      [0, 203],
      [-12, 46],
      [19, 88]
    ],
    [
      [8117, 4988],
      [52, 1],
      [96, -42],
      [46, 35],
      [35, 5],
      [80, -31],
      [51, 11]
    ],
    [
      [8477, 4967],
      [26, -98]
    ],
    [
      [8503, 4869],
      [-40, -106],
      [7, -86],
      [63, -127],
      [-7, -47],
      [53, -63]
    ],
    [
      [8797, 3899],
      [-58, 90],
      [-71, 36],
      [-60, -30],
      [-46, 11]
    ],
    [
      [8562, 4006],
      [-4, 23],
      [21, 122],
      [61, 60]
    ],
    [
      [8640, 4211],
      [34, -119],
      [76, -82],
      [75, -102]
    ],
    [
      [6764, 5577],
      [-15, 66],
      [57, 41],
      [143, -20],
      [97, 2]
    ],
    [
      [7046, 5666],
      [16, -23],
      [131, -39],
      [46, 7]
    ],
    [
      [7239, 5611],
      [2, -33],
      [-37, -38],
      [-51, -12],
      [-43, -98],
      [15, -32],
      [-31, -63],
      [-58, -56],
      [-88, 1],
      [-40, -42],
      [-45, 57],
      [-36, 9]
    ],
    [
      [6827, 5304],
      [16, 55],
      [-3, 55],
      [17, 163],
      [-93, 0]
    ],
    [
      [8083, 6488],
      [-39, 79],
      [100, 25],
      [84, -8]
    ],
    [
      [8228, 6584],
      [-27, -114]
    ],
    [
      [8201, 6470],
      [-84, 28],
      [-34, -10]
    ],
    [
      [8813, 3807],
      [-8, -20],
      [44, -80],
      [129, -68],
      [34, 0]
    ],
    [
      [9012, 3639],
      [-112, -171],
      [-52, -3],
      [-71, -59]
    ],
    [
      [8777, 3406],
      [-43, 19],
      [-48, -48],
      [-57, 11],
      [-50, 48],
      [-28, 0],
      [-34, 60]
    ],
    [
      [8517, 3496],
      [-23, 63],
      [-18, 13],
      [-38, 88],
      [27, 18]
    ],
    [
      [8465, 3678],
      [0, 51]
    ],
    [
      [8465, 3729],
      [12, 61],
      [18, 16],
      [21, 67],
      [24, 28],
      [22, 105]
    ],
    [
      [8252, 7133],
      [-6, -41],
      [61, -38],
      [-37, -43],
      [46, -65],
      [-27, -49],
      [36, -42],
      [-16, -38],
      [59, -39],
      [-15, -29],
      [-121, -106]
    ],
    [
      [8232, 6643],
      [-206, -38],
      [-62, 50],
      [-10, 108],
      [55, 69],
      [117, 74],
      [-60, 51]
    ],
    [
      [8066, 6957],
      [-14, 111],
      [-114, 67]
    ],
    [
      [7938, 7135],
      [161, -26],
      [58, 67],
      [112, -3],
      [-17, -40]
    ],
    [
      [14178, 2189],
      [6, -46],
      [-46, -1],
      [12, 45],
      [28, 2]
    ],
    [
      [4700, 215],
      [47, 35],
      [77, -37],
      [-105, -24],
      [-19, 26]
    ],
    [
      [7346, 6015],
      [20, -4]
    ],
    [
      [7392, 5812],
      [-4, -55],
      [27, -76]
    ],
    [
      [7415, 5681],
      [-35, -32],
      [-79, 15],
      [-58, -18],
      [-4, -35]
    ],
    [
      [7046, 5666],
      [20, 34],
      [8, 114],
      [-70, 89],
      [-61, 22],
      [-4, 42],
      [52, 12],
      [66, -15],
      [25, 40],
      [92, 45],
      [46, 59]
    ],
    [
      [7560, 2954],
      [-67, 105],
      [-24, 59],
      [27, 121]
    ],
    [
      [7496, 3239],
      [71, 3],
      [0, 69]
    ],
    [
      [6876, 6263],
      [-55, 11],
      [0, 62]
    ],
    [
      [6821, 6336],
      [76, -34],
      [-21, -39]
    ],
    [
      [6986, 6123],
      [-32, 50],
      [-14, 69],
      [59, -5],
      [-22, 69],
      [-77, 40],
      [-23, 84],
      [46, 106],
      [79, 0],
      [-42, -62],
      [84, 8],
      [-5, -102],
      [38, -74],
      [27, -9],
      [35, -87],
      [48, -11],
      [-44, -113],
      [-53, 0],
      [-112, -31],
      [-27, 56],
      [35, 12]
    ],
    [
      [8765, 5558],
      [-4, 63],
      [-59, 45]
    ],
    [
      [8702, 5666],
      [96, -12],
      [54, -28],
      [68, -13],
      [37, -37]
    ],
    [
      [8845, 5532],
      [-38, 28],
      [-42, -2]
    ],
    [
      [7163, 3521],
      [-120, -70],
      [-35, 16]
    ],
    [
      [7122, 3812],
      [14, -48],
      [4, -159],
      [23, -84]
    ],
    [
      [6787, 3621],
      [-19, -21],
      [-33, 70],
      [-19, -8]
    ],
    [
      [6716, 3662],
      [-35, 94],
      [-52, -12],
      [-32, -53]
    ],
    [
      [6597, 3691],
      [-53, 75],
      [-21, 47]
    ],
    [
      [6523, 3813],
      [54, 44],
      [2, 44]
    ],
    [
      [6579, 3901],
      [47, -14],
      [40, 6]
    ],
    [
      [6666, 3893],
      [53, -34],
      [33, 28],
      [38, -54],
      [14, -68]
    ],
    [
      [6455, 3934],
      [5, 25]
    ],
    [
      [6460, 3959],
      [-5, -25]
    ],
    [
      [6523, 3813],
      [-38, 28],
      [-24, 49]
    ],
    [
      [6461, 3890],
      [45, 14],
      [73, -3]
    ],
    [
      [7496, 3239],
      [7, 73]
    ],
    [
      [8152, 5517],
      [-45, 7],
      [-20, -47],
      [-62, -27],
      [5, -39],
      [41, -43],
      [1, -32],
      [-94, -47],
      [-21, 84],
      [-39, 75]
    ],
    [
      [7953, 5518],
      [76, 28]
    ],
    [
      [8154, 5574],
      [-2, -57]
    ],
    [
      [5271, 7909],
      [322, 52],
      [456, -1],
      [589, -128],
      [-218, -67],
      [-78, -78],
      [48, -101],
      [-54, -51],
      [18, -103],
      [-161, -127],
      [67, -81],
      [-23, -31],
      [-214, -95],
      [-200, -41],
      [-55, -61],
      [-85, -40],
      [-137, -30],
      [-54, -113],
      [-65, -45],
      [16, -45],
      [-38, -104],
      [-56, -3],
      [-59, 47],
      [-78, 0],
      [-133, 158],
      [-26, 89],
      [-55, 53],
      [-12, 62],
      [39, 67],
      [60, 22],
      [-128, 50],
      [27, 111],
      [-28, 59],
      [-153, 167],
      [-106, 34],
      [-286, -2],
      [-115, 54],
      [-69, 82],
      [295, 55],
      [-92, 41],
      [212, 94],
      [629, 50]
    ],
    [
      [3557, 3967],
      [-46, 11],
      [-38, 35]
    ],
    [
      [3473, 4013],
      [18, 87],
      [51, 1],
      [-21, 100],
      [74, -1]
    ],
    [
      [3603, 4091],
      [28, -10]
    ],
    [
      [3631, 4081],
      [-37, -38],
      [-8, -37]
    ],
    [
      [3586, 4006],
      [-29, -39]
    ],
    [
      [4964, 3313],
      [20, 76]
    ],
    [
      [4984, 3389],
      [-18, 73],
      [20, 49]
    ],
    [
      [4986, 3511],
      [43, -20],
      [49, -72]
    ],
    [
      [4757, 3660],
      [26, -21],
      [77, -116]
    ],
    [
      [4860, 3523],
      [-6, -52],
      [-29, -57],
      [60, -124]
    ],
    [
      [4718, 3479],
      [-27, 43],
      [11, 43],
      [34, 19],
      [-10, 42],
      [31, 34]
    ],
    [
      [3667, 3924],
      [-19, 23]
    ],
    [
      [3648, 3947],
      [2, 23],
      [-64, 36]
    ],
    [
      [3631, 4081],
      [88, 16],
      [64, -10],
      [49, -48]
    ],
    [
      [3832, 4039],
      [-70, -12],
      [-35, -54],
      [-38, -5],
      [-22, -44]
    ],
    [
      [7866, 5808],
      [7, -60]
    ],
    [
      [7855, 5621],
      [-4, -10]
    ],
    [
      [7851, 5611],
      [-96, 60],
      [-34, 42],
      [-10, 47],
      [-47, 25]
    ],
    [
      [7664, 5785],
      [63, -3],
      [49, 60]
    ],
    [
      [7776, 5842],
      [42, -31],
      [48, -3]
    ],
    [
      [4284, 4214],
      [-39, 23],
      [-3, 59],
      [42, 13]
    ],
    [
      [7793, 5935],
      [34, -21],
      [117, 49],
      [50, -11]
    ],
    [
      [7994, 5952],
      [26, -31]
    ],
    [
      [8020, 5921],
      [-25, -12],
      [-42, -78],
      [-32, -11]
    ],
    [
      [7921, 5820],
      [-55, -12]
    ],
    [
      [7776, 5842],
      [-14, 20]
    ],
    [
      [12065, 2673],
      [4, -29]
    ],
    [
      [12069, 2644],
      [-25, -42],
      [-18, 48],
      [39, 23]
    ],
    [
      [11786, 2718],
      [48, -35],
      [-74, -19],
      [26, 54]
    ],
    [
      [11418, 2794],
      [76, -6],
      [9, 23],
      [74, -27],
      [13, -37],
      [60, -10],
      [3, -56],
      [-43, 23],
      [-77, 2],
      [-83, 33],
      [-45, -2],
      [-73, 24],
      [-43, 28],
      [27, 55],
      [48, -4],
      [54, -46]
    ],
    [
      [12282, 3004],
      [-19, -20],
      [-82, 3],
      [9, 32],
      [49, 2],
      [43, -17]
    ],
    [
      [12699, 3033],
      [1, -187],
      [1, -186]
    ],
    [
      [12701, 2660],
      [-35, 46],
      [-101, -6],
      [17, 47],
      [25, 16],
      [-30, 110],
      [-76, 48],
      [-33, 5],
      [-59, 53],
      [-66, 41],
      [-6, 69],
      [-36, 10],
      [57, 61],
      [64, -23],
      [17, -114],
      [41, -34],
      [33, 60],
      [45, 35],
      [36, 0],
      [63, -40],
      [42, -11]
    ],
    [
      [12076, 3263],
      [-32, -57],
      [-68, 0],
      [-101, -11],
      [-6, -43],
      [59, -80],
      [38, -73],
      [-8, -20],
      [35, -66],
      [-21, -54],
      [-35, 45],
      [-5, 38],
      [-52, 72],
      [5, -149],
      [-41, 9],
      [11, 52],
      [-6, 55],
      [-29, 40],
      [49, 193],
      [34, 42],
      [31, -17],
      [96, -5],
      [46, 29]
    ],
    [
      [12212, 3246],
      [-22, -44],
      [-29, 37],
      [8, 46],
      [43, -39]
    ],
    [
      [11459, 3296],
      [34, -71],
      [51, 8],
      [42, 34],
      [37, -16],
      [32, 12],
      [50, 165],
      [80, -10]
    ],
    [
      [11785, 3418],
      [-23, -52],
      [29, -54],
      [-6, -26],
      [44, -53],
      [-47, -7],
      [-11, -91],
      [-39, -39],
      [-1, -57],
      [-21, -67],
      [-45, -26],
      [-16, 35],
      [-48, 22],
      [-46, -21],
      [-15, 28],
      [-58, 4],
      [-6, 76],
      [-39, 65],
      [-1, 103],
      [23, 38]
    ],
    [
      [11307, 2846],
      [-43, -1],
      [-34, 48],
      [-51, 47],
      [-47, 81],
      [-49, 123],
      [-36, 48],
      [-25, 94],
      [-36, 36],
      [-21, 49],
      [-71, 95],
      [-3, 29],
      [87, -13],
      [87, -119],
      [37, -61],
      [40, -1],
      [57, -88],
      [30, -26],
      [-16, -46],
      [37, -22],
      [20, -72],
      [30, -5],
      [19, -36],
      [-12, -160]
    ],
    [
      [10330, 4908],
      [-41, -80],
      [128, -81],
      [54, -7],
      [22, -30],
      [112, -18],
      [2, 84]
    ],
    [
      [10972, 4798],
      [-11, -32],
      [-77, -65],
      [1, -32],
      [-41, -123],
      [-31, 13],
      [-6, -103],
      [-20, -14]
    ],
    [
      [10644, 4443],
      [-7, -21],
      [-75, -11],
      [2, -43],
      [-21, -33],
      [-57, -39],
      [-44, -68],
      [-70, -73],
      [0, -26],
      [-73, -38],
      [-12, -44],
      [10, -121],
      [-17, -55],
      [0, -97],
      [-38, -46],
      [-53, -91],
      [-38, 54],
      [-33, 137],
      [-35, 82],
      [-17, 108],
      [-36, 78],
      [-28, 184],
      [-8, 123],
      [-57, -34],
      [-28, 7],
      [-52, 69],
      [8, 43],
      [-47, 48]
    ],
    [
      [9818, 4536],
      [26, 39],
      [87, -1],
      [-34, 123],
      [-26, 26],
      [43, 59],
      [47, -4],
      [41, 60],
      [63, 115],
      [0, 42],
      [33, 33],
      [-32, 28],
      [-28, 89],
      [20, 24],
      [60, -14],
      [44, 9],
      [38, 48]
    ],
    [
      [6876, 6263],
      [6, -41],
      [-30, -51],
      [-70, -34],
      [-55, 9],
      [31, 60],
      [-20, 58],
      [83, 72]
    ],
    [
      [9254, 5309],
      [64, 44],
      [71, 4],
      [75, -35],
      [79, -101]
    ],
    [
      [9543, 5221],
      [-28, -113],
      [17, -121],
      [33, -47],
      [-36, -52]
    ],
    [
      [9529, 4888],
      [36, -65],
      [38, -25],
      [1, -50],
      [22, -36],
      [-57, -29],
      [-15, -67]
    ],
    [
      [9554, 4616],
      [-163, 38],
      [-16, 70],
      [-19, 10],
      [-70, -38],
      [-49, 19],
      [-40, 44],
      [-38, 16],
      [-55, 131],
      [-61, -13]
    ],
    [
      [9043, 4893],
      [-36, 61],
      [7, 42],
      [-21, 43],
      [-48, 31],
      [-28, 55],
      [27, 97],
      [-26, 18],
      [-26, 68]
    ],
    [
      [8892, 5308],
      [-26, 129],
      [27, 16]
    ],
    [
      [9055, 5374],
      [13, -43],
      [64, -40],
      [56, -10],
      [66, 28]
    ],
    [
      [9043, 4893],
      [-24, 3]
    ],
    [
      [9019, 4896],
      [-27, 5],
      [-29, -55]
    ],
    [
      [8963, 4846],
      [-73, 5],
      [-112, 115],
      [-58, 40],
      [-48, 15]
    ],
    [
      [8672, 5021],
      [-17, 70]
    ],
    [
      [8655, 5091],
      [89, 60],
      [11, 111],
      [42, 49]
    ],
    [
      [8797, 5311],
      [95, -3]
    ],
    [
      [6547, 6983],
      [35, -76],
      [-51, -43],
      [-148, -50],
      [-162, 27],
      [-48, 53],
      [13, 78],
      [59, 9],
      [62, -39],
      [110, 15],
      [65, 31],
      [65, -5]
    ],
    [
      [8534, 5053],
      [-7, -18]
    ],
    [
      [8527, 5035],
      [-6, -52]
    ],
    [
      [8521, 4983],
      [-18, -114]
    ],
    [
      [8477, 4967],
      [34, 107]
    ],
    [
      [8511, 5074],
      [27, 11]
    ],
    [
      [8538, 5085],
      [-4, -32]
    ],
    [
      [7735, 5368],
      [-17, -91],
      [-105, 56],
      [52, 24],
      [70, 11]
    ],
    [
      [7485, 5539],
      [24, -41],
      [-6, -75],
      [-49, -1],
      [-1, 69],
      [32, 48]
    ],
    [
      [7667, 5842],
      [6, -52]
    ],
    [
      [7673, 5790],
      [-64, -12],
      [10, -74],
      [37, -29],
      [20, -48],
      [74, -69],
      [64, -38],
      [-43, -62],
      [-40, 14],
      [-71, 66],
      [-60, 29],
      [-63, 70],
      [-13, 57],
      [-52, 26],
      [-57, -39]
    ],
    [
      [8534, 5053],
      [44, -23],
      [77, 61]
    ],
    [
      [8672, 5021],
      [-88, -37],
      [40, -57],
      [-76, -75],
      [-44, 9]
    ],
    [
      [8504, 4861],
      [-1, 8]
    ],
    [
      [8521, 4983],
      [6, 52]
    ],
    [
      [12447, 5135],
      [-17, -54],
      [-36, 4],
      [-14, 45],
      [67, 5]
    ],
    [
      [12699, 5306],
      [-9, -74],
      [-20, -41],
      [-51, -26],
      [-70, -4],
      [-56, -65],
      [-28, 65],
      [-69, -13],
      [-47, -27],
      [-33, -140],
      [-44, -2],
      [10, 51],
      [-42, 56],
      [128, 122],
      [78, 18],
      [43, -12],
      [41, 101],
      [26, -27],
      [81, 79],
      [25, 71],
      [-7, 64],
      [17, 36],
      [41, 11],
      [22, -80],
      [-1, -46],
      [-36, -58],
      [1, -59]
    ],
    [
      [12814, 5708],
      [65, -52],
      [-59, -15],
      [-35, -57],
      [-62, 39],
      [-21, -63],
      [-44, -1],
      [-6, 57],
      [20, 45],
      [42, 3],
      [23, 124],
      [77, -80]
    ],
    [
      [9928, 5599],
      [-75, -50],
      [-93, -12],
      [-27, 47],
      [3, 57],
      [-47, 42],
      [-114, -12],
      [-38, 51],
      [-102, 67],
      [-101, -34],
      [1, -210]
    ],
    [
      [9335, 5545],
      [-20, -3],
      [-54, 61],
      [-63, -31]
    ],
    [
      [9198, 5572],
      [0, 57],
      [-46, 20],
      [-18, 51],
      [17, 70],
      [68, 0],
      [0, 92],
      [-73, 11],
      [-82, -37]
    ],
    [
      [9064, 5836],
      [-41, 77],
      [-64, 37],
      [43, 118],
      [46, 9],
      [81, 61],
      [62, 2],
      [134, -62],
      [42, 23],
      [181, -14],
      [10, 28],
      [-64, 39],
      [68, 58],
      [-10, 59],
      [147, 20],
      [119, 35],
      [35, 24],
      [71, -12],
      [54, -46],
      [85, -47],
      [85, 36],
      [51, -44],
      [88, -146],
      [21, 30],
      [55, -33],
      [57, 15],
      [85, -79],
      [51, 8],
      [21, -35]
    ],
    [
      [10296, 5604],
      [-44, 29],
      [-124, 8],
      [-71, 18],
      [-29, -46],
      [-65, 19],
      [-35, -33]
    ],
    [
      [8767, 3085],
      [-53, -51],
      [-26, -101],
      [-16, -19]
    ],
    [
      [8672, 2914],
      [-57, 57],
      [-3, 33],
      [-149, 123]
    ],
    [
      [8463, 3127],
      [-1, 60],
      [45, 104],
      [-21, 94],
      [-19, 40]
    ],
    [
      [8467, 3425],
      [50, 71]
    ],
    [
      [8777, 3406],
      [-34, -65],
      [0, -208],
      [24, -48]
    ],
    [
      [10036, 5437],
      [-75, -9],
      [-49, 19],
      [18, 37]
    ],
    [
      [9930, 5484],
      [30, -6],
      [51, 42],
      [-47, 30],
      [-57, 7],
      [21, 42]
    ],
    [
      [11179, 3878],
      [-9, 70],
      [26, 47],
      [50, 11],
      [38, -8]
    ],
    [
      [11284, 3998],
      [32, -23],
      [18, 40],
      [35, -21]
    ],
    [
      [11369, 3994],
      [9, -38],
      [-5, -69],
      [-66, -44],
      [-58, -62]
    ],
    [
      [11249, 3781],
      [-33, 9],
      [-37, 88]
    ],
    [
      [12199, 5390],
      [44, -104],
      [-15, -97],
      [-103, -40],
      [3, 74],
      [-18, 60],
      [3, 58]
    ],
    [
      [12113, 5341],
      [86, 49]
    ],
    [
      [7915, 5618],
      [8, 13]
    ],
    [
      [7923, 5631],
      [51, -33]
    ],
    [
      [7974, 5598],
      [-38, -22]
    ],
    [
      [9019, 4896],
      [17, -81]
    ],
    [
      [9036, 4815],
      [-73, 31]
    ],
    [
      [11284, 3998],
      [14, 74],
      [-31, 50],
      [-3, 56],
      [-30, 47],
      [-38, -16],
      [-35, 9],
      [-42, -35],
      [9, 112],
      [-27, 2],
      [-19, 53]
    ],
    [
      [11082, 4350],
      [41, 58]
    ],
    [
      [11163, 4467],
      [41, -98],
      [49, 0],
      [15, -50],
      [-37, -35],
      [48, -35],
      [97, -198],
      [-7, -57]
    ],
    [
      [8511, 5074],
      [34, 89]
    ],
    [
      [8545, 5163],
      [24, -25],
      [-31, -53]
    ],
    [
      [6816, 3431],
      [-51, 27],
      [-97, 112]
    ],
    [
      [6668, 3570],
      [48, 92]
    ],
    [
      [7708, 4490],
      [-28, -22],
      [-21, 31],
      [-63, 25]
    ],
    [
      [7496, 4915],
      [18, 61],
      [60, 57],
      [2, 44]
    ],
    [
      [7576, 5077],
      [148, -50],
      [18, -51],
      [92, -35],
      [42, -28],
      [38, 41],
      [-8, 44],
      [40, 55],
      [81, -5],
      [13, -25],
      [67, -17],
      [10, -18]
    ],
    [
      [8110, 4440],
      [0, -114],
      [-46, -25]
    ],
    [
      [8064, 4301],
      [-157, 110],
      [-158, 110],
      [-41, -31]
    ],
    [
      [10357, 3612],
      [-6, -60],
      [-51, -29],
      [-19, 45],
      [-7, 82],
      [17, 93],
      [28, -31],
      [38, -100]
    ],
    [
      [8267, 1525],
      [-5, -64],
      [-43, -33],
      [-30, 44],
      [61, 70],
      [17, -17]
    ],
    [
      [8020, 6289],
      [-58, 50]
    ],
    [
      [7962, 6339],
      [-8, 48]
    ],
    [
      [7954, 6387],
      [45, 17],
      [105, 2],
      [65, -43]
    ],
    [
      [8050, 6265],
      [-30, 24]
    ],
    [
      [7954, 6387],
      [21, 79],
      [69, -23],
      [39, 45]
    ],
    [
      [8201, 6470],
      [35, -75]
    ],
    [
      [6778, 4764],
      [-6, 0],
      [-36, -46],
      [-66, 2],
      [-44, -121],
      [-55, -63],
      [-12, -78],
      [-21, -47],
      [-90, -4]
    ],
    [
      [6448, 4407],
      [30, 72],
      [11, 59],
      [35, 46],
      [26, 99],
      [26, 21],
      [45, 81],
      [37, 7],
      [85, 102],
      [-10, 71],
      [20, 79],
      [25, 39],
      [69, 50],
      [39, 94],
      [53, -24],
      [97, -10]
    ],
    [
      [8174, 5940],
      [36, 14],
      [63, -35],
      [31, -68],
      [-66, -67]
    ],
    [
      [8238, 5784],
      [-4, 75],
      [-60, 81]
    ],
    [
      [9081, 2468],
      [20, -62],
      [16, -96],
      [-38, -107],
      [-2, -49],
      [-35, -145],
      [-57, -255],
      [-68, -37],
      [-54, 35],
      [-31, 168],
      [7, 41],
      [37, 72],
      [4, 37],
      [-20, 115],
      [19, 68],
      [74, 26],
      [56, 68],
      [72, 121]
    ],
    [
      [3473, 4013],
      [-45, 62],
      [-53, 33],
      [-74, -31],
      [-169, 87],
      [-43, 42],
      [-63, 22],
      [-59, 58],
      [-29, 65],
      [18, 36],
      [-29, 98],
      [-95, 137],
      [-34, 23],
      [-1, 49],
      [-43, 42],
      [-73, 102],
      [-36, 127],
      [-65, 36],
      [4, -94],
      [68, -100],
      [8, -36],
      [45, -64],
      [36, -105],
      [17, -80],
      [-75, 75],
      [-5, 73],
      [-85, 64],
      [12, 82],
      [-54, 56],
      [-64, 171]
    ],
    [
      [2487, 5043],
      [92, -1],
      [149, -68],
      [111, 0],
      [0, 24],
      [69, 0],
      [57, -63],
      [23, -62],
      [54, -34],
      [25, 45],
      [60, -21],
      [57, -106],
      [20, -67],
      [74, -28]
    ],
    [
      [3278, 4662],
      [-23, -92],
      [-6, -104],
      [27, -104],
      [51, -104],
      [59, -39],
      [119, 42],
      [25, 23],
      [19, 99],
      [69, 28],
      [59, 3],
      [9, -40],
      [-22, -34],
      [-18, -114],
      [-18, 14]
    ],
    [
      [7974, 5598],
      [32, 5]
    ],
    [
      [6639, 4018],
      [20, 44],
      [41, -15],
      [43, 21],
      [159, 1],
      [2, 46],
      [-19, 247],
      [-19, 247],
      [60, 2]
    ],
    [
      [7290, 4277],
      [0, -132],
      [-25, -73],
      [-89, -14],
      [-40, -23]
    ],
    [
      [6666, 3893],
      [-27, 125]
    ],
    [
      [11020, 3750],
      [8, 86],
      [-13, 33],
      [3, 63],
      [-16, 30],
      [-20, 141],
      [-17, 47],
      [-71, -69],
      [-47, 18],
      [14, 71],
      [-9, 54],
      [-77, 140]
    ],
    [
      [11082, 4350],
      [-46, -39],
      [-28, -2],
      [-34, -72],
      [60, -130],
      [-19, -89],
      [26, -45],
      [19, -111],
      [-40, -112]
    ],
    [
      [7888, 5577],
      [-37, 34]
    ],
    [
      [7881, 5671],
      [42, -40]
    ],
    [
      [10593, 6002],
      [42, 10],
      [135, 76],
      [75, -18],
      [27, -27],
      [97, -17],
      [38, 40],
      [-16, 34],
      [41, 59],
      [127, -45],
      [8, -43],
      [55, -24],
      [88, 18],
      [39, -7],
      [63, -57],
      [87, -9],
      [89, 24],
      [57, 40],
      [45, -25],
      [47, 4]
    ],
    [
      [8488, 2522],
      [77, -11],
      [119, 47],
      [32, 33]
    ],
    [
      [8716, 2591],
      [6, -26],
      [5, -196],
      [7, -28],
      [-27, -81],
      [-25, -35],
      [-81, -50],
      [-104, -126],
      [-3, -40],
      [33, -91],
      [-3, -117],
      [-114, -91],
      [10, -59]
    ],
    [
      [8420, 1651],
      [-30, 1]
    ],
    [
      [8390, 1652],
      [-10, 51]
    ],
    [
      [8380, 1703],
      [4, 84],
      [-29, 121]
    ],
    [
      [8355, 1908],
      [42, 65],
      [20, 80],
      [4, 172],
      [-103, 69]
    ],
    [
      [8318, 2294],
      [-3, 41],
      [120, 47]
    ],
    [
      [8435, 2382],
      [49, -36],
      [-2, -91],
      [25, -35],
      [29, 52],
      [-4, 74],
      [-44, 58],
      [-11, 75],
      [11, 43]
    ],
    [
      [6639, 4018],
      [-50, 81],
      [-45, 32],
      [-74, -26]
    ],
    [
      [6470, 4105],
      [12, 113],
      [-5, 113],
      [-31, 52]
    ],
    [
      [6446, 4383],
      [8, 19],
      [155, 0],
      [-7, 82],
      [47, 35],
      [-2, 146],
      [130, -3],
      [0, 87]
    ],
    [
      [8435, 2382],
      [-21, 15],
      [25, 73],
      [-8, 47],
      [15, 62],
      [-29, 75]
    ],
    [
      [8417, 2654],
      [39, -11],
      [21, -43],
      [11, -78]
    ],
    [
      [11162, 3537],
      [49, -78],
      [5, -118],
      [29, -86],
      [-29, -4],
      [-84, 88],
      [-28, 68],
      [-19, 78],
      [-5, 66]
    ],
    [
      [11080, 3551],
      [69, -37],
      [13, 23]
    ],
    [
      [11459, 3296],
      [29, -20],
      [31, 11],
      [8, 49],
      [64, 23],
      [48, 81]
    ],
    [
      [11688, 3493],
      [51, 85],
      [38, -54],
      [59, -33],
      [-22, -53],
      [-29, -20]
    ],
    [
      [7768, 1547],
      [-45, 84],
      [-32, 186],
      [-6, 99],
      [-35, 71],
      [-30, 105],
      [-32, 56],
      [-3, 44]
    ],
    [
      [8039, 2179],
      [33, 13],
      [41, -21]
    ],
    [
      [7908, 1764],
      [0, -211],
      [-57, -33],
      [-83, 27]
    ],
    [
      [13679, 1975],
      [-11, -33],
      [-52, 70],
      [11, 18],
      [52, -55]
    ],
    [
      [7708, 4490],
      [10, -90],
      [32, -52],
      [-24, -141],
      [-2, -74],
      [-50, -54],
      [-17, -76],
      [37, -86]
    ],
    [
      [7682, 3895],
      [-34, 62],
      [-40, -29],
      [-31, 16],
      [-56, -3],
      [-44, -26],
      [-48, 30],
      [-38, -13],
      [-54, 43],
      [-43, -7],
      [-27, -69],
      [-3, -51]
    ],
    [
      [7457, 3454],
      [-71, -30],
      [-31, 1],
      [-35, 77],
      [-28, 38],
      [-65, 0]
    ],
    [
      [3730, 3816],
      [-32, 41],
      [-31, 67]
    ],
    [
      [3832, 4039],
      [-17, -106],
      [-4, -126]
    ],
    [
      [7252, 6119],
      [55, 100],
      [87, 22]
    ],
    [
      [7938, 7135],
      [-154, -63],
      [-66, -104],
      [-125, -175],
      [2, -76],
      [26, -29],
      [-13, -67],
      [-51, -73]
    ],
    [
      [7557, 6548],
      [-26, 36],
      [-79, -67],
      [-52, -13],
      [-55, 29],
      [-26, 194],
      [36, 36],
      [104, 49],
      [78, 59],
      [168, 190],
      [175, 114],
      [152, 23],
      [60, 47],
      [144, 9],
      [123, -42],
      [-8, -51]
    ],
    [
      [8351, 7161],
      [-99, -28]
    ],
    [
      [7843, 7741],
      [130, -43],
      [-99, -22],
      [-76, -100],
      [-132, 32],
      [-132, 130],
      [259, 23],
      [50, -20]
    ],
    [
      [8128, 7782],
      [19, -51],
      [-231, 2],
      [-108, 43],
      [320, 6]
    ],
    [
      [13966, 840],
      [37, 0],
      [12, -48],
      [-78, -120],
      [-33, -22],
      [-34, -95],
      [-50, -42],
      [-105, 24],
      [15, 64],
      [161, 148],
      [38, 89],
      [37, 2]
    ],
    [
      [14029, 1113],
      [29, -60],
      [55, -38],
      [70, 10],
      [-21, -84],
      [-37, -41],
      [-41, -81],
      [-86, 102],
      [29, 41],
      [5, 81],
      [-65, 122],
      [51, -1],
      [11, -51]
    ],
    [
      [9222, 4134],
      [-44, 134]
    ],
    [
      [9178, 4268],
      [119, 58],
      [27, 114],
      [-19, 41]
    ],
    [
      [9352, 4607],
      [40, -60],
      [52, -18],
      [43, -71],
      [-52, -108],
      [-33, -40],
      [5, -38],
      [-47, -28],
      [-52, -77],
      [-86, -33]
    ],
    [
      [9339, 4672],
      [8, -19]
    ],
    [
      [9818, 4536],
      [-29, 15],
      [-42, 85],
      [-74, -11],
      [-119, -9]
    ],
    [
      [9529, 4888],
      [67, -29],
      [98, 9],
      [52, 24],
      [1, 48],
      [22, 32],
      [79, 18],
      [30, 85],
      [25, 15],
      [51, 102],
      [-14, 53],
      [23, 25],
      [131, 36]
    ],
    [
      [4040, 3595],
      [-29, 85],
      [-20, 16],
      [-54, -52],
      [-16, -49],
      [-33, 50],
      [-49, 7]
    ],
    [
      [3856, 3728],
      [43, -44],
      [74, 47],
      [60, -21],
      [28, -33]
    ],
    [
      [4337, 2132],
      [-43, 56],
      [-79, 58],
      [-101, 97],
      [-10, 64],
      [-34, 75],
      [-76, 219],
      [-28, 69],
      [-60, 60],
      [13, 26],
      [-19, 55],
      [13, 39],
      [31, 37]
    ],
    [
      [12121, 3663],
      [6, -70],
      [-46, -23],
      [1, -70],
      [-47, 34],
      [-36, 72],
      [-55, -13],
      [16, 48],
      [46, 38],
      [14, -26],
      [37, 41],
      [58, 19],
      [6, -50]
    ],
    [
      [12026, 3769],
      [-39, -71],
      [-25, 39],
      [23, 67],
      [45, 20],
      [-4, -55]
    ],
    [
      [11943, 3862],
      [48, -42],
      [-43, -41],
      [-5, 83]
    ],
    [
      [11920, 4240],
      [25, -16],
      [23, -65],
      [-11, -47],
      [-23, -19],
      [3, -92],
      [38, 1],
      [50, -32],
      [-4, -31],
      [-47, -3],
      [-25, 34],
      [-37, -8],
      [-41, 76],
      [12, 150],
      [13, 52],
      [24, 0]
    ],
    [
      [13288, 2791],
      [-46, 53],
      [14, 19],
      [32, -72]
    ],
    [
      [13133, 2868],
      [-68, -48],
      [-77, 33],
      [99, 16],
      [61, 66],
      [-15, -67]
    ],
    [
      [12699, 3033],
      [142, -73],
      [49, -57],
      [6, -34],
      [66, -36],
      [-26, -36],
      [9, -38],
      [35, -38],
      [25, -60],
      [40, -44],
      [1, -30],
      [-73, 15],
      [-54, 68],
      [-20, 50],
      [-52, 25],
      [-58, -36],
      [6, -41],
      [-32, -20],
      [-62, 12]
    ],
    [
      [7680, 6256],
      [138, 64],
      [81, -25]
    ],
    [
      [7899, 6295],
      [121, -6]
    ],
    [
      [8052, 6132],
      [19, -50],
      [-59, -70],
      [1, -23]
    ],
    [
      [8013, 5989],
      [-38, 23],
      [-69, -15],
      [-39, 16]
    ],
    [
      [12289, 5607],
      [6, -11]
    ],
    [
      [12295, 5596],
      [-44, -35],
      [1, -40],
      [-86, -65],
      [33, -66]
    ],
    [
      [12113, 5341],
      [-58, 20],
      [27, 74],
      [-45, 30]
    ],
    [
      [6827, 5304],
      [-58, -13],
      [2, 79],
      [-27, 28],
      [30, 116],
      [-10, 63]
    ],
    [
      [9131, 4598],
      [23, -8]
    ],
    [
      [9154, 4590],
      [-23, 8]
    ],
    [
      [8020, 5921],
      [85, -8],
      [69, 27]
    ],
    [
      [8238, 5784],
      [54, -12]
    ],
    [
      [8292, 5772],
      [-31, -21],
      [-11, -69]
    ],
    [
      [8017, 5712],
      [-43, 31],
      [-53, 77]
    ],
    [
      [12804, 6085],
      [40, -102],
      [-59, 19],
      [-24, -82],
      [38, -59],
      [-64, -2],
      [-1, 117],
      [12, 120],
      [-24, 56],
      [4, 79],
      [63, -32],
      [15, -114]
    ],
    [
      [7899, 6295],
      [63, 44]
    ],
    [
      [197, 6991],
      [18, 27],
      [107, -8],
      [78, -54],
      [-104, -31],
      [-2, -56],
      [-53, -10],
      [-176, 63],
      [-65, -23],
      [0, 228],
      [201, -101],
      [-4, -35]
    ],
    [
      [12861, 7504],
      [-32, -42],
      [-211, -12],
      [-78, 37],
      [21, 39],
      [157, 9],
      [143, -31]
    ],
    [
      [9397, 7227],
      [-153, 2],
      [-87, 72],
      [165, 176],
      [219, 67],
      [277, -1],
      [-261, -56],
      [-123, -54],
      [-120, -111],
      [7, -48],
      [76, -47]
    ],
    [
      [9064, 5836],
      [-57, -43],
      [-39, -60],
      [36, -54],
      [-4, -38],
      [43, -68]
    ],
    [
      [8702, 5666],
      [-96, 70],
      [-5, 43],
      [33, 48],
      [-1, 49]
    ],
    [
      [8633, 5876],
      [22, 42],
      [38, 4],
      [13, 97],
      [-81, 18],
      [-105, 38],
      [-64, 100],
      [-78, -13]
    ],
    [
      [8228, 6584],
      [4, 59]
    ],
    [
      [8351, 7161],
      [214, -29],
      [150, -64],
      [33, -65],
      [-109, -46],
      [-176, 44],
      [35, -50],
      [5, -84],
      [89, 41],
      [95, -36],
      [7, 56],
      [93, 56],
      [72, -23],
      [96, 35],
      [71, 48],
      [220, 77],
      [-9, -38],
      [151, 15],
      [149, 27],
      [-21, 52],
      [118, -17],
      [198, -83],
      [26, 30],
      [-89, 48],
      [-9, 90],
      [128, 115],
      [105, -15],
      [20, -76],
      [102, 48],
      [157, 2],
      [34, 76],
      [250, 16],
      [13, 68],
      [465, 76],
      [215, 71],
      [151, -55],
      [116, -1],
      [120, -49],
      [-10, -30],
      [-177, -66],
      [181, -33],
      [190, -1],
      [10, -27],
      [165, -8],
      [2, 44],
      [147, -10],
      [64, -30],
      [-5, -61],
      [112, -68],
      [102, 34],
      [238, 6],
      [-29, 53],
      [53, 25],
      [356, -37],
      [138, -78],
      [159, 11],
      [112, -33],
      [44, -58],
      [273, 8],
      [118, -32],
      [-15, 61],
      [209, -12],
      [169, -52],
      [0, -228],
      [-67, -52],
      [42, -63],
      [-225, -76],
      [-118, -75],
      [-71, 14],
      [-103, -45],
      [-110, 4],
      [-59, -93],
      [46, -35],
      [-6, -84],
      [-36, -2],
      [0, -72],
      [-70, -30],
      [-13, -65],
      [-59, -14],
      [-12, -58],
      [-72, -14],
      [-39, 211],
      [19, 79],
      [35, 61],
      [62, 13],
      [139, 131],
      [71, 45],
      [-40, 29],
      [-100, -63],
      [-33, 71],
      [-102, -20],
      [-99, -96],
      [33, -35],
      [-150, -21],
      [3, 42],
      [-62, 8],
      [-48, -28],
      [-121, 10],
      [-131, -17],
      [-128, -111],
      [-151, -135],
      [62, -8],
      [19, -36],
      [108, 12],
      [57, -62],
      [1, -49],
      [-30, -57],
      [-22, -160],
      [-73, -122],
      [-133, -167],
      [-52, -34],
      [-50, 28],
      [-59, -62]
    ],
    [
      [11278, 7661],
      [-223, -22],
      [72, 75],
      [151, -53]
    ],
    [
      [11074, 7694],
      [-262, 31],
      [-84, 53],
      [189, 52],
      [167, -84],
      [-10, -52]
    ],
    [
      [8324, 3116],
      [16, -32],
      [-14, -41]
    ],
    [
      [8291, 3105],
      [33, 11]
    ],
    [
      [6446, 4383],
      [2, 24]
    ],
    [
      [8813, 4117],
      [-20, 64],
      [-20, 21],
      [-32, 94],
      [-45, 49],
      [-27, 54],
      [-2, 74],
      [-23, 63],
      [-40, 35],
      [-11, 46],
      [-82, 170],
      [-7, 74]
    ],
    [
      [9036, 4815],
      [16, -49],
      [53, -58],
      [-1, -42],
      [27, -68]
    ],
    [
      [9154, 4590],
      [8, -22]
    ],
    [
      [9178, 4268],
      [-114, -21],
      [-36, -26],
      [-47, -70],
      [-71, 28],
      [-73, 9],
      [-24, -71]
    ],
    [
      [8465, 3723],
      [-30, 72],
      [0, 83],
      [-36, -28],
      [4, -34],
      [-42, -73],
      [-53, 27],
      [-42, -51],
      [-97, 9],
      [-28, 49],
      [-28, -8],
      [-21, -78],
      [-26, -16]
    ],
    [
      [8066, 3675],
      [-3, 2]
    ],
    [
      [8026, 3819],
      [-33, 104],
      [10, 78],
      [29, 77],
      [34, -3],
      [-2, 226]
    ],
    [
      [8579, 4440],
      [13, -56],
      [-3, -70],
      [15, -68],
      [36, -35]
    ],
    [
      [8465, 3729],
      [0, -6]
    ],
    [
      [8465, 3723],
      [0, -45]
    ],
    [
      [8467, 3425],
      [-25, -27],
      [-101, -16]
    ],
    [
      [8093, 3653],
      [-27, 22]
    ],
    [
      [6460, 3959],
      [-19, 76],
      [29, 70]
    ],
    [
      [6461, 3890],
      [-6, 44]
    ],
    [
      [6668, 3570],
      [-39, 27],
      [-28, 51],
      [-4, 43]
    ],
    [
      [3648, 3947],
      [-28, -12],
      [-63, 32]
    ],
    [
      [8827, 3837],
      [39, -58],
      [101, 21],
      [91, 34]
    ],
    [
      [9058, 3834],
      [-1, -112],
      [-45, -83]
    ],
    [
      [9058, 3834],
      [85, 35],
      [-3, -79],
      [-19, -82],
      [-44, -137],
      [-33, -84],
      [-81, -142],
      [-136, -147],
      [-60, -113]
    ],
    [
      [4860, 3523],
      [47, -11],
      [36, 14],
      [43, -15]
    ],
    [
      [4984, 3389],
      [-20, -76]
    ],
    [
      [8013, 5989],
      [-19, -37]
    ],
    [
      [7664, 5785],
      [9, 5]
    ],
    [
      [8066, 6957],
      [-68, -16],
      [-32, -75],
      [-139, -95],
      [-29, -80],
      [66, -72],
      [-36, -65],
      [-42, -14],
      [-37, -149],
      [-48, 6],
      [-22, -46],
      [-46, -2],
      [-76, 199]
    ],
    [
      [8390, 1652],
      [-31, -32],
      [-24, 31],
      [14, 58],
      [31, -6]
    ],
    [
      [8545, 5163],
      [6, 68]
    ],
    [
      [8551, 5231],
      [36, 46],
      [44, 16],
      [53, -11],
      [113, 29]
    ],
    [
      [7195, 3533],
      [-32, -12]
    ],
    [
      [11179, 3878],
      [-35, 27],
      [-28, 44],
      [-35, 0],
      [-3, -64],
      [-34, -134],
      [28, -43],
      [23, -102],
      [67, -69]
    ],
    [
      [11080, 3551],
      [-62, 110],
      [2, 89]
    ],
    [
      [10088, 5322],
      [-69, 4],
      [-56, -43],
      [-12, 67],
      [-29, 33],
      [-27, -51],
      [-91, -25]
    ],
    [
      [9804, 5307],
      [23, 57],
      [-9, 43],
      [46, 105],
      [53, 13],
      [13, -41]
    ],
    [
      [9254, 5309],
      [-1, 101],
      [-47, 61],
      [8, 49],
      [38, -14],
      [35, 18],
      [-40, 67],
      [-49, -19]
    ],
    [
      [9335, 5545],
      [105, 82],
      [54, -30],
      [4, -45],
      [72, -20],
      [19, -59],
      [71, -67],
      [93, -52],
      [-1, -35]
    ],
    [
      [9752, 5319],
      [-70, -14],
      [-7, -46],
      [-92, -60],
      [-40, 22]
    ],
    [
      [12065, 2673],
      [4, -29]
    ],
    [
      [7454, 5295],
      [43, 23],
      [57, -94],
      [-6, -50],
      [-25, -29],
      [53, -68]
    ],
    [
      [8551, 5231],
      [-24, 42],
      [-33, 13],
      [-27, -32],
      [-60, -7],
      [-32, 31],
      [-43, 2],
      [-36, -31],
      [-38, 31],
      [-43, -1],
      [-52, 88],
      [19, 45],
      [-26, 27],
      [45, 54],
      [60, 3],
      [17, 44],
      [75, -8],
      [94, 53],
      [65, 1],
      [126, -62],
      [81, 4],
      [46, 30]
    ],
    [
      [8229, 5584],
      [-15, -57],
      [-50, -49],
      [-12, 39]
    ],
    [
      [11939, 4577],
      [-42, -139],
      [-25, 91],
      [56, 100],
      [11, -52]
    ],
    [
      [8672, 2914],
      [-18, -71],
      [27, -53],
      [-10, -94],
      [31, -92],
      [14, -13]
    ],
    [
      [8417, 2654],
      [-80, 50]
    ],
    [
      [8324, 3116],
      [14, 8],
      [125, 3]
    ],
    [
      [8633, 5876],
      [-128, -47],
      [10, -77],
      [-54, -33],
      [-13, 39],
      [-43, 16],
      [34, 44],
      [-102, 28],
      [-45, -74]
    ],
    [
      [5009, 1249],
      [-17, -35],
      [-45, -32],
      [-113, 28],
      [-24, 31]
    ],
    [
      [4465, 5763],
      [-36, -46],
      [-82, -36],
      [-27, -48],
      [7, -79],
      [-52, -31],
      [-81, -17],
      [-8, -53],
      [-61, -101],
      [-10, -59],
      [10, -78],
      [-25, -42],
      [-86, -54],
      [-70, -78],
      [-41, -61],
      [-6, -41],
      [57, -220],
      [-13, -95],
      [-31, -1],
      [-61, 131],
      [2, 61],
      [-42, 79],
      [-55, -17],
      [-51, 44],
      [-110, -5],
      [-9, -66],
      [-59, -1],
      [-29, 30],
      [-63, 6],
      [-58, -17],
      [-75, -67],
      [-31, -53],
      [9, -86]
    ],
    [
      [2487, 5043],
      [-7, 29],
      [-48, 56],
      [-73, 24],
      [-53, 98],
      [-80, 160],
      [-27, 77],
      [8, 97],
      [-13, 44],
      [16, 54],
      [9, 104],
      [-26, 163],
      [57, -19],
      [11, 55]
    ],
    [
      [1957, 6317],
      [-57, 39],
      [-11, 50],
      [-51, 47],
      [-21, 54],
      [-147, 21],
      [-83, 60],
      [-106, 31],
      [-55, -5],
      [-125, 50],
      [-36, -51],
      [-146, -47],
      [-34, 52],
      [-57, -41],
      [29, -28],
      [-38, -41],
      [-81, -41],
      [-85, -82],
      [-84, 0],
      [112, 90],
      [7, 43],
      [-59, 5],
      [-112, 70],
      [-77, 10],
      [-60, 40],
      [-31, 57],
      [62, 94],
      [59, -5],
      [83, 67],
      [-58, 19],
      [-158, 7],
      [-67, 56],
      [144, 52],
      [111, -26],
      [-147, 110],
      [137, 131],
      [211, 59],
      [171, -44],
      [291, -35],
      [155, -16]
    ],
    [
      [9804, 5307],
      [-52, 12]
    ],
    [
      [4299, 3855],
      [-3, -46],
      [50, 23],
      [50, 4],
      [27, -50],
      [78, 5],
      [53, -33],
      [23, 32],
      [62, -13],
      [75, -59],
      [7, -46],
      [36, -12]
    ],
    [
      [11396, 4414],
      [-53, -48],
      [-42, -95],
      [67, -135],
      [60, -81],
      [18, -105],
      [-5, -101],
      [-78, -75],
      [-81, -100],
      [-15, 36],
      [11, 39],
      [-29, 32]
    ],
    [
      [9222, 4134],
      [-29, -15],
      [-8, -45],
      [-103, -51],
      [-35, -41],
      [-121, -40],
      [-25, -34],
      [-60, -4],
      [-31, 177],
      [3, 36]
    ],
    [
      [8285, 1917],
      [70, -9]
    ],
    [
      [8420, 1651],
      [-25, -114],
      [-35, -38],
      [-50, -99],
      [-73, -93],
      [-96, -68],
      [-127, 5],
      [-117, -55],
      [-54, 55],
      [-1, 126],
      [-46, 102],
      [-28, 75]
    ],
    [
      [8318, 2294],
      [-30, -8],
      [-75, -93],
      [-22, -38],
      [-70, 11]
    ]
  ],
  "transform": { "scale": [0.025277348686982174, 0.017479843553601524], "translate": [-180, -55.61015614321084] },
  "objects": {
    "countries1": {
      "type": "GeometryCollection",
      "geometries": [
        {
          "arcs": [[[0, 1, 2, 3]], [[4, 5, 6]]],
          "type": "MultiPolygon",
          "properties": { "name": "Angola", "Alpha-2": "AO" },
          "id": "AGO"
        },
        {
          "arcs": [[7, 8, 9, 10, 11]],
          "type": "Polygon",
          "properties": { "name": "Albania", "Alpha-2": "AL" },
          "id": "ALB"
        },
        {
          "arcs": [[12, 13, 14, 15, 16]],
          "type": "Polygon",
          "properties": { "name": "United Arab Emirates", "Alpha-2": "AE" },
          "id": "ARE"
        },
        {
          "arcs": [[[17, 18]], [[19, 20, 21, 22, 23, 24]]],
          "type": "MultiPolygon",
          "properties": { "name": "Argentina", "Alpha-2": "AR" },
          "id": "ARG"
        },
        {
          "arcs": [[25, 26, 27, 28, 29]],
          "type": "Polygon",
          "properties": { "name": "Armenia", "Alpha-2": "AM" },
          "id": "ARM"
        },
        {
          "arcs": [[30]],
          "type": "Polygon",
          "properties": { "name": "French Southern and Antarctic Lands", "Alpha-2": "TF" },
          "id": "ATF"
        },
        {
          "arcs": [[[31]], [[32]]],
          "type": "MultiPolygon",
          "properties": { "name": "Australia", "Alpha-2": "AU" },
          "id": "AUS"
        },
        {
          "arcs": [[33, 34, 35, 36, 37, 38, 39]],
          "type": "Polygon",
          "properties": { "name": "Austria", "Alpha-2": "AT" },
          "id": "AUT"
        },
        {
          "arcs": [[41, 42, 43, -27, 44, 45]],
          "type": "Polygon",
          "properties": { "name": "Azerbaijan", "Alpha-2": "AZ" },
          "id": "AZE"
        },
        {
          "arcs": [[46, 47, 48]],
          "type": "Polygon",
          "properties": { "name": "Burundi", "Alpha-2": "BI" },
          "id": "BDI"
        },
        {
          "arcs": [[49, 50, 51, 52, 53, 54]],
          "type": "Polygon",
          "properties": { "name": "Belgium", "Alpha-2": "BE" },
          "id": "BEL"
        },
        {
          "arcs": [[55, 56, 57, 58, 59]],
          "type": "Polygon",
          "properties": { "name": "Benin", "Alpha-2": "BJ" },
          "id": "BEN"
        },
        {
          "arcs": [[60, 61, 62, -58, 63, 64]],
          "type": "Polygon",
          "properties": { "name": "Burkina Faso", "Alpha-2": "BF" },
          "id": "BFA"
        },
        {
          "arcs": [[65, 66, 67]],
          "type": "Polygon",
          "properties": { "name": "Bangladesh", "Alpha-2": "BD" },
          "id": "BGD"
        },
        {
          "arcs": [[68, 69, 70, 71, 72, 73]],
          "type": "Polygon",
          "properties": { "name": "Bulgaria", "Alpha-2": "BG" },
          "id": "BGR"
        },
        { "type": null, "properties": { "name": "The Bahamas", "Alpha-2": "BS" }, "id": "BHS" },
        {
          "arcs": [[74, 75, 76]],
          "type": "Polygon",
          "properties": { "name": "Bosnia and Herzegovina", "Alpha-2": "BA" },
          "id": "BIH"
        },
        {
          "arcs": [[77, 78, 79, 80, 81]],
          "type": "Polygon",
          "properties": { "name": "Belarus", "Alpha-2": "BY" },
          "id": "BLR"
        },
        { "arcs": [[82, 83, 84]], "type": "Polygon", "properties": { "name": "Belize", "Alpha-2": "BZ" }, "id": "BLZ" },
        {
          "arcs": [[85, 86, 87, 88, 89, 90, 91, 92]],
          "type": "Polygon",
          "properties": { "name": "Bermuda", "Alpha-2": "BM" },
          "id": "BMU"
        },
        {
          "arcs": [[93, 94, 95, 96, -25]],
          "type": "Polygon",
          "properties": { "name": "Bolivia", "Alpha-2": "BO" },
          "id": "BOL"
        },
        {
          "arcs": [[-21, 97, -96, 98, 99, 100, 101, 102, 103, 104, 105]],
          "type": "Polygon",
          "properties": { "name": "Brazil", "Alpha-2": "BR" },
          "id": "BRA"
        },
        { "arcs": [[106, 107]], "type": "Polygon", "properties": { "name": "Brunei", "Alpha-2": "BN" }, "id": "BRN" },
        { "arcs": [[108, 109]], "type": "Polygon", "properties": { "name": "Bhutan", "Alpha-2": "BT" }, "id": "BTN" },
        {
          "arcs": [[110, 111, 112, 113]],
          "type": "Polygon",
          "properties": { "name": "Botswana", "Alpha-2": "BW" },
          "id": "BWA"
        },
        {
          "arcs": [[114, 115, 116, 117, 118, 119, 120]],
          "type": "Polygon",
          "properties": { "name": "Central African Republic", "Alpha-2": "CF" },
          "id": "CAF"
        },
        {
          "arcs": [
            [[121]],
            [[122]],
            [[123]],
            [[124]],
            [[125, 126, 127, 128]],
            [[129]],
            [[130]],
            [[131]],
            [[132]],
            [[133]],
            [[134]],
            [[135]],
            [[136]],
            [[137]],
            [[138]],
            [[139]]
          ],
          "type": "MultiPolygon",
          "properties": { "name": "Canada", "Alpha-2": "CA" },
          "id": "CAN"
        },
        {
          "arcs": [[-37, 140, 141, 142]],
          "type": "Polygon",
          "properties": { "name": "Switzerland", "Alpha-2": "CH" },
          "id": "CHE"
        },
        {
          "arcs": [[[-18, 143]], [[-24, 144, 145, -94]]],
          "type": "MultiPolygon",
          "properties": { "name": "Chile", "Alpha-2": "CL" },
          "id": "CHL"
        },
        {
          "arcs": [
            [[146]],
            [[147, 148, 149, 150, 151, 152, 153, -110, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164]]
          ],
          "type": "MultiPolygon",
          "properties": { "name": "China", "Alpha-2": "CN" },
          "id": "CHN"
        },
        {
          "arcs": [[165, 166, 167, 168, -61, 169]],
          "type": "Polygon",
          "properties": { "name": "Ivory Coast", "Alpha-2": "CI" },
          "id": "CIV"
        },
        {
          "arcs": [[170, 171, 172, 173, 174, 175, -121, 176]],
          "type": "Polygon",
          "properties": { "name": "Cameroon", "Alpha-2": "CM" },
          "id": "CMR"
        },
        {
          "arcs": [[177, 178, -47, 179, 180, -4, 181, -7, 182, -119, 183, 184]],
          "type": "Polygon",
          "properties": { "name": "Democratic Republic of the Congo", "Alpha-2": "CD" },
          "id": "COD"
        },
        {
          "arcs": [[-6, 185, 186, -177, -120, -183]],
          "type": "Polygon",
          "properties": { "name": "Republic of the Congo", "Alpha-2": "CG" },
          "id": "COG"
        },
        {
          "arcs": [[187, 188, 189, 190, 191, -100, 192]],
          "type": "Polygon",
          "properties": { "name": "Colombia", "Alpha-2": "CO" },
          "id": "COL"
        },
        {
          "arcs": [[193, 194, 195, 196]],
          "type": "Polygon",
          "properties": { "name": "Costa Rica", "Alpha-2": "CR" },
          "id": "CRI"
        },
        { "arcs": [[197]], "type": "Polygon", "properties": { "name": "Cuba", "Alpha-2": "CU" }, "id": "CUB" },
        {
          "arcs": [[198, 199]],
          "type": "Polygon",
          "properties": { "name": "Northern Cyprus", "Alpha-2": null },
          "id": "-99"
        },
        { "arcs": [[200, -200]], "type": "Polygon", "properties": { "name": "Cyprus", "Alpha-2": "CY" }, "id": "CYP" },
        {
          "arcs": [[-39, 201, 202, 203]],
          "type": "Polygon",
          "properties": { "name": "Czech Republic", "Alpha-2": "CZ" },
          "id": "CZE"
        },
        {
          "arcs": [[204, 205, -202, -38, -143, 206, 207, -51, 208, 209, 210]],
          "type": "Polygon",
          "properties": { "name": "Germany", "Alpha-2": "DE" },
          "id": "DEU"
        },
        {
          "arcs": [[211, 212, 213, 214]],
          "type": "Polygon",
          "properties": { "name": "Djibouti", "Alpha-2": "DJ" },
          "id": "DJI"
        },
        { "arcs": [[-211, 215]], "type": "Polygon", "properties": { "name": "Denmark", "Alpha-2": "DK" }, "id": "DNK" },
        {
          "arcs": [[216, 217]],
          "type": "Polygon",
          "properties": { "name": "Dominican Republic", "Alpha-2": "DO" },
          "id": "DOM"
        },
        {
          "arcs": [[218, 219, 220, 221, 222, 223, 224, 225]],
          "type": "Polygon",
          "properties": { "name": "Algeria", "Alpha-2": "DZ" },
          "id": "DZA"
        },
        {
          "arcs": [[226, -188, 227]],
          "type": "Polygon",
          "properties": { "name": "Ecuador", "Alpha-2": "EC" },
          "id": "ECU"
        },
        {
          "arcs": [[228, 229, 230, 231, 232]],
          "type": "Polygon",
          "properties": { "name": "Egypt", "Alpha-2": "EG" },
          "id": "EGY"
        },
        {
          "arcs": [[233, 234, 235, -215]],
          "type": "Polygon",
          "properties": { "name": "Eritrea", "Alpha-2": "ER" },
          "id": "ERI"
        },
        {
          "arcs": [[236, 237, 238, 239]],
          "type": "Polygon",
          "properties": { "name": "Spain", "Alpha-2": "ES" },
          "id": "ESP"
        },
        {
          "arcs": [[240, 241, 242]],
          "type": "Polygon",
          "properties": { "name": "Estonia", "Alpha-2": "EE" },
          "id": "EST"
        },
        {
          "arcs": [[-234, -214, 243, 244, 245, 246, 247, 248]],
          "type": "Polygon",
          "properties": { "name": "Ethiopia", "Alpha-2": "ET" },
          "id": "ETH"
        },
        {
          "arcs": [[249, 250, 251, 252]],
          "type": "Polygon",
          "properties": { "name": "Finland", "Alpha-2": "FI" },
          "id": "FIN"
        },
        { "arcs": [[253]], "type": "Polygon", "properties": { "name": "Fiji", "Alpha-2": "FJ" }, "id": "FJI" },
        {
          "arcs": [[254]],
          "type": "Polygon",
          "properties": { "name": "Falkland Islands", "Alpha-2": "FK" },
          "id": "FLK"
        },
        {
          "arcs": [[255, -207, -142, 256, 257, -238, 258, -53]],
          "type": "Polygon",
          "properties": { "name": "France", "Alpha-2": "FR" },
          "id": "FRA"
        },
        {
          "arcs": [[259, 260, -171, -187]],
          "type": "Polygon",
          "properties": { "name": "Gabon", "Alpha-2": "GA" },
          "id": "GAB"
        },
        {
          "arcs": [[[261, 262]], [[263]]],
          "type": "MultiPolygon",
          "properties": { "name": "United Kingdom", "Alpha-2": "GB" },
          "id": "GBR"
        },
        {
          "arcs": [[264, 265, -45, -26, 266]],
          "type": "Polygon",
          "properties": { "name": "Georgia", "Alpha-2": "GE" },
          "id": "GEO"
        },
        {
          "arcs": [[267, -170, -65, 268]],
          "type": "Polygon",
          "properties": { "name": "Ghana", "Alpha-2": "GH" },
          "id": "GHA"
        },
        {
          "arcs": [[269, 270, 271, 272, 273, 274, -168]],
          "type": "Polygon",
          "properties": { "name": "Guinea", "Alpha-2": "GN" },
          "id": "GIN"
        },
        { "arcs": [[275, 276]], "type": "Polygon", "properties": { "name": "Gambia", "Alpha-2": "GM" }, "id": "GMB" },
        {
          "arcs": [[277, 278, -273]],
          "type": "Polygon",
          "properties": { "name": "Guinea Bissau", "Alpha-2": "GW" },
          "id": "GNB"
        },
        {
          "arcs": [[279, -172, -261]],
          "type": "Polygon",
          "properties": { "name": "Equatorial Guinea", "Alpha-2": "GQ" },
          "id": "GNQ"
        },
        {
          "arcs": [[280, -8, 281, -72, 282]],
          "type": "Polygon",
          "properties": { "name": "Greece", "Alpha-2": "GR" },
          "id": "GRC"
        },
        { "arcs": [[283]], "type": "Polygon", "properties": { "name": "Greenland", "Alpha-2": "GL" }, "id": "GRL" },
        {
          "arcs": [[284, 285, -85, 286, 287, 288]],
          "type": "Polygon",
          "properties": { "name": "Guatemala", "Alpha-2": "GT" },
          "id": "GTM"
        },
        {
          "arcs": [[289, 290, 291, -104]],
          "type": "Polygon",
          "properties": { "name": "French Guiana", "Alpha-2": "GF" },
          "id": "GUF"
        },
        {
          "arcs": [[292, 293, -102, 294]],
          "type": "Polygon",
          "properties": { "name": "Guyana", "Alpha-2": "GY" },
          "id": "GUY"
        },
        {
          "arcs": [[295, 296, -288, 297, 298]],
          "type": "Polygon",
          "properties": { "name": "Honduras", "Alpha-2": "HN" },
          "id": "HND"
        },
        {
          "arcs": [[299, -77, 300, 301, 302, 303]],
          "type": "Polygon",
          "properties": { "name": "Croatia", "Alpha-2": "HR" },
          "id": "HRV"
        },
        { "arcs": [[-218, 304]], "type": "Polygon", "properties": { "name": "Haiti", "Alpha-2": "HT" }, "id": "HTI" },
        {
          "arcs": [[-34, 305, 306, 307, 308, -304, 309]],
          "type": "Polygon",
          "properties": { "name": "Hungary", "Alpha-2": "HU" },
          "id": "HUN"
        },
        {
          "arcs": [[[310, 311]], [[312]], [[313]], [[314]], [[315, 316]], [[317]], [[318]], [[319, 320]], [[321]]],
          "type": "MultiPolygon",
          "properties": { "name": "Indonesia", "Alpha-2": "ID" },
          "id": "IDN"
        },
        {
          "arcs": [[-157, 322, -155, -109, -154, 323, -68, 324, 325]],
          "type": "Polygon",
          "properties": { "name": "India", "Alpha-2": "IN" },
          "id": "IND"
        },
        { "arcs": [[326, -262]], "type": "Polygon", "properties": { "name": "Ireland", "Alpha-2": "IE" }, "id": "IRL" },
        {
          "arcs": [[327, 328, 329, 330, 331, 332, -41, -28, -44, 333]],
          "type": "Polygon",
          "properties": { "name": "Iran", "Alpha-2": "IR" },
          "id": "IRN"
        },
        {
          "arcs": [[-332, 334, 335, 336, 337, 338, 339]],
          "type": "Polygon",
          "properties": { "name": "Iraq", "Alpha-2": "IQ" },
          "id": "IRQ"
        },
        { "arcs": [[340]], "type": "Polygon", "properties": { "name": "Iceland", "Alpha-2": "IS" }, "id": "ISL" },
        {
          "arcs": [[341, 342, 343, -232, 344, 345, 346]],
          "type": "Polygon",
          "properties": { "name": "Israel", "Alpha-2": "IL" },
          "id": "ISR"
        },
        {
          "arcs": [[[347]], [[348]], [[349, 350, -257, -141, -36]]],
          "type": "MultiPolygon",
          "properties": { "name": "Italy", "Alpha-2": "IT" },
          "id": "ITA"
        },
        { "type": null, "properties": { "name": "Jamaica", "Alpha-2": "JM" }, "id": "JAM" },
        {
          "arcs": [[-342, 351, -338, 352, 353, -344, 354]],
          "type": "Polygon",
          "properties": { "name": "Jordan", "Alpha-2": "JO" },
          "id": "JOR"
        },
        {
          "arcs": [[[355]], [[356]], [[357]]],
          "type": "MultiPolygon",
          "properties": { "name": "Japan", "Alpha-2": "JP" },
          "id": "JPN"
        },
        {
          "arcs": [[358, 359, 360, 361, -162, 362]],
          "type": "Polygon",
          "properties": { "name": "Kazakhstan", "Alpha-2": "KZ" },
          "id": "KAZ"
        },
        {
          "arcs": [[363, 364, 365, 366, -246, 367]],
          "type": "Polygon",
          "properties": { "name": "Kenya", "Alpha-2": "KE" },
          "id": "KEN"
        },
        {
          "arcs": [[-363, -161, 368, 369]],
          "type": "Polygon",
          "properties": { "name": "Kyrgyzstan", "Alpha-2": "KG" },
          "id": "KGZ"
        },
        {
          "arcs": [[370, 371, 372, 373]],
          "type": "Polygon",
          "properties": { "name": "Cambodia", "Alpha-2": "KH" },
          "id": "KHM"
        },
        {
          "arcs": [[374, 375]],
          "type": "Polygon",
          "properties": { "name": "South Korea", "Alpha-2": "KR" },
          "id": "KOR"
        },
        {
          "arcs": [[-11, 376, 377, 378]],
          "type": "Polygon",
          "properties": { "name": "Kosovo", "Alpha-2": null },
          "id": "CS-KM"
        },
        {
          "arcs": [[379, 380, -336]],
          "type": "Polygon",
          "properties": { "name": "Kuwait", "Alpha-2": "KW" },
          "id": "KWT"
        },
        {
          "arcs": [[381, 382, -152, 383, -372]],
          "type": "Polygon",
          "properties": { "name": "Laos", "Alpha-2": "LA" },
          "id": "LAO"
        },
        {
          "arcs": [[-346, 384, 385]],
          "type": "Polygon",
          "properties": { "name": "Lebanon", "Alpha-2": "LB" },
          "id": "LBN"
        },
        {
          "arcs": [[386, 387, -270, -167]],
          "type": "Polygon",
          "properties": { "name": "Liberia", "Alpha-2": "LR" },
          "id": "LBR"
        },
        {
          "arcs": [[388, -226, 389, 390, -230, 391, 392]],
          "type": "Polygon",
          "properties": { "name": "Libya", "Alpha-2": "LY" },
          "id": "LBY"
        },
        { "arcs": [[393]], "type": "Polygon", "properties": { "name": "Sri Lanka", "Alpha-2": "LK" }, "id": "LKA" },
        { "arcs": [[394]], "type": "Polygon", "properties": { "name": "Lesotho", "Alpha-2": "LS" }, "id": "LSO" },
        {
          "arcs": [[395, 396, 397, -78, 398]],
          "type": "Polygon",
          "properties": { "name": "Lithuania", "Alpha-2": "LT" },
          "id": "LTU"
        },
        {
          "arcs": [[-208, -256, -52]],
          "type": "Polygon",
          "properties": { "name": "Luxembourg", "Alpha-2": "LU" },
          "id": "LUX"
        },
        {
          "arcs": [[399, -243, 400, -79, -398]],
          "type": "Polygon",
          "properties": { "name": "Latvia", "Alpha-2": "LV" },
          "id": "LVA"
        },
        {
          "arcs": [[-223, 401, 402]],
          "type": "Polygon",
          "properties": { "name": "Morocco", "Alpha-2": "MA" },
          "id": "MAR"
        },
        { "arcs": [[403, 404]], "type": "Polygon", "properties": { "name": "Moldova", "Alpha-2": "MD" }, "id": "MDA" },
        { "arcs": [[405]], "type": "Polygon", "properties": { "name": "Madagascar", "Alpha-2": "MG" }, "id": "MDG" },
        {
          "arcs": [[-83, -286, 406, 407, 408]],
          "type": "Polygon",
          "properties": { "name": "Mexico", "Alpha-2": "MX" },
          "id": "MEX"
        },
        {
          "arcs": [[-379, 409, -73, -282, -12]],
          "type": "Polygon",
          "properties": { "name": "Macedonia", "Alpha-2": "MK" },
          "id": "MKD"
        },
        {
          "arcs": [[410, -220, 411, -62, -169, -275, 412]],
          "type": "Polygon",
          "properties": { "name": "Mali", "Alpha-2": "ML" },
          "id": "MLI"
        },
        { "type": null, "properties": { "name": "Malta", "Alpha-2": "MT" }, "id": "MLT" },
        {
          "arcs": [[413, -66, -324, -153, -383, 414]],
          "type": "Polygon",
          "properties": { "name": "Myanmar", "Alpha-2": "MM" },
          "id": "MMR"
        },
        {
          "arcs": [[-10, 415, -301, -76, 416, -377]],
          "type": "Polygon",
          "properties": { "name": "Montenegro", "Alpha-2": "ME" },
          "id": "MNE"
        },
        {
          "arcs": [[417, -164]],
          "type": "Polygon",
          "properties": { "name": "Mongolia", "Alpha-2": "MN" },
          "id": "MNG"
        },
        {
          "arcs": [[418, 419, 420, 421, 422, 423, 424, 425]],
          "type": "Polygon",
          "properties": { "name": "Mozambique", "Alpha-2": "MZ" },
          "id": "MOZ"
        },
        {
          "arcs": [[426, 427, 428, -221, -411]],
          "type": "Polygon",
          "properties": { "name": "Mauritania", "Alpha-2": "MR" },
          "id": "MRT"
        },
        {
          "arcs": [[-426, 429, 430]],
          "type": "Polygon",
          "properties": { "name": "Malawi", "Alpha-2": "MW" },
          "id": "MWI"
        },
        {
          "arcs": [[[431, 432]], [[-320, 433, -108, 434]]],
          "type": "MultiPolygon",
          "properties": { "name": "Malaysia", "Alpha-2": "MY" },
          "id": "MYS"
        },
        {
          "arcs": [[435, -2, 436, -112, 437]],
          "type": "Polygon",
          "properties": { "name": "Namibia", "Alpha-2": "NA" },
          "id": "NAM"
        },
        { "arcs": [[438]], "type": "Polygon", "properties": { "name": "New Caledonia", "Alpha-2": "NC" }, "id": "NCL" },
        {
          "arcs": [[-63, -412, -219, -389, 439, -175, 440, -59]],
          "type": "Polygon",
          "properties": { "name": "Niger", "Alpha-2": "NE" },
          "id": "NER"
        },
        {
          "arcs": [[441, -60, -441, -174]],
          "type": "Polygon",
          "properties": { "name": "Nigeria", "Alpha-2": "NG" },
          "id": "NGA"
        },
        {
          "arcs": [[442, -299, 443, -195]],
          "type": "Polygon",
          "properties": { "name": "Nicaragua", "Alpha-2": "NI" },
          "id": "NIC"
        },
        {
          "arcs": [[-209, -50, -55, 444]],
          "type": "Polygon",
          "properties": { "name": "Netherlands", "Alpha-2": "NL" },
          "id": "NLD"
        },
        {
          "arcs": [[[-253, 445, 446, 447]], [[448]], [[449]]],
          "type": "MultiPolygon",
          "properties": { "name": "Norway", "Alpha-2": "NO" },
          "id": "NOR"
        },
        { "arcs": [[-323, -156]], "type": "Polygon", "properties": { "name": "Nepal", "Alpha-2": "NP" }, "id": "NPL" },
        {
          "arcs": [[[450]], [[451]]],
          "type": "MultiPolygon",
          "properties": { "name": "New Zealand", "Alpha-2": "NZ" },
          "id": "NZL"
        },
        {
          "arcs": [[452, 453, -16, 454]],
          "type": "Polygon",
          "properties": { "name": "Oman", "Alpha-2": "OM" },
          "id": "OMN"
        },
        {
          "arcs": [[-158, -326, 456, -330, 457]],
          "type": "Polygon",
          "properties": { "name": "Pakistan", "Alpha-2": "PK" },
          "id": "PAK"
        },
        {
          "arcs": [[458, -197, 459, -190]],
          "type": "Polygon",
          "properties": { "name": "Panama", "Alpha-2": "PA" },
          "id": "PAN"
        },
        {
          "arcs": [[-146, 460, -228, -193, -99, -95]],
          "type": "Polygon",
          "properties": { "name": "Peru", "Alpha-2": "PE" },
          "id": "PER"
        },
        {
          "arcs": [[[461]], [[462]], [[463]], [[464]]],
          "type": "MultiPolygon",
          "properties": { "name": "Philippines", "Alpha-2": "PH" },
          "id": "PHL"
        },
        {
          "arcs": [[[465]], [[466]], [[-316, 467]]],
          "type": "MultiPolygon",
          "properties": { "name": "Papua New Guinea", "Alpha-2": "PG" },
          "id": "PNG"
        },
        {
          "arcs": [[-206, 468, 469, -399, -82, 470, 471, -203]],
          "type": "Polygon",
          "properties": { "name": "Poland", "Alpha-2": "PL" },
          "id": "POL"
        },
        { "type": null, "properties": { "name": "Puerto Rico", "Alpha-2": "PR" }, "id": "PRI" },
        {
          "arcs": [[472, 473, -376, 474, -149]],
          "type": "Polygon",
          "properties": { "name": "North Korea", "Alpha-2": "KP" },
          "id": "PRK"
        },
        {
          "arcs": [[-240, 475]],
          "type": "Polygon",
          "properties": { "name": "Portugal", "Alpha-2": "PT" },
          "id": "PRT"
        },
        {
          "arcs": [[-97, -98, -20]],
          "type": "Polygon",
          "properties": { "name": "Paraguay", "Alpha-2": "PY" },
          "id": "PRY"
        },
        { "arcs": [[476, 477]], "type": "Polygon", "properties": { "name": "Qatar", "Alpha-2": "QA" }, "id": "QAT" },
        {
          "arcs": [[478, -405, 479, 480, -69, 481, -308]],
          "type": "Polygon",
          "properties": { "name": "Romania", "Alpha-2": "RO" },
          "id": "ROU"
        },
        {
          "arcs": [
            [[482]],
            [[-470, 483, -396]],
            [[484]],
            [[485]],
            [[486]],
            [
              [-148, -165, -418, -163, -362, 487, -42, -46, -266, 488, 489, -80, -401, -242, 490, -250, -448, 491, -473]
            ],
            [[492]],
            [[493]]
          ],
          "type": "MultiPolygon",
          "properties": { "name": "Russia", "Alpha-2": "RU" },
          "id": "RUS"
        },
        {
          "arcs": [[494, -48, -179, 495]],
          "type": "Polygon",
          "properties": { "name": "Rwanda", "Alpha-2": "RW" },
          "id": "RWA"
        },
        {
          "arcs": [[-402, -222, -429, 496]],
          "type": "Polygon",
          "properties": { "name": "Western Sahara", "Alpha-2": "EH" },
          "id": "ESH"
        },
        {
          "arcs": [[497, -353, -337, -381, 498, -478, 499, -17, -454, 500]],
          "type": "Polygon",
          "properties": { "name": "Saudi Arabia", "Alpha-2": "SA" },
          "id": "SAU"
        },
        {
          "arcs": [[501, 502, -116, 503, -392, -229, 504, -235, -249, 505]],
          "type": "Polygon",
          "properties": { "name": "Sudan", "Alpha-2": "SD" },
          "id": "SDN"
        },
        {
          "arcs": [[506, -247, -367, 507, -184, -118, 508, -502]],
          "type": "Polygon",
          "properties": { "name": "South Sudan", "Alpha-2": null },
          "id": "SSD"
        },
        {
          "arcs": [[509, -427, -413, -274, -279, 510, -277]],
          "type": "Polygon",
          "properties": { "name": "Senegal", "Alpha-2": "SN" },
          "id": "SEN"
        },
        { "type": null, "properties": { "name": "Solomon Islands", "Alpha-2": "SB" }, "id": "SLB" },
        {
          "arcs": [[511, -271, -388]],
          "type": "Polygon",
          "properties": { "name": "Sierra Leone", "Alpha-2": "SL" },
          "id": "SLE"
        },
        {
          "arcs": [[512, -289, -297]],
          "type": "Polygon",
          "properties": { "name": "El Salvador", "Alpha-2": "SV" },
          "id": "SLV"
        },
        {
          "arcs": [[-244, -213, 513, 514]],
          "type": "Polygon",
          "properties": { "name": "Somaliland", "Alpha-2": null },
          "id": "-99"
        },
        {
          "arcs": [[-368, -245, -515, 515]],
          "type": "Polygon",
          "properties": { "name": "Somalia", "Alpha-2": "SO" },
          "id": "SOM"
        },
        {
          "arcs": [[-74, -410, -378, -417, -75, -300, -309, -482]],
          "type": "Polygon",
          "properties": { "name": "Republic of Serbia", "Alpha-2": "RS" },
          "id": "SRB"
        },
        {
          "arcs": [[516, -291, 517, -103, -294]],
          "type": "Polygon",
          "properties": { "name": "Suriname", "Alpha-2": "SR" },
          "id": "SUR"
        },
        {
          "arcs": [[-472, 518, -306, -40, -204]],
          "type": "Polygon",
          "properties": { "name": "Slovakia", "Alpha-2": "SK" },
          "id": "SVK"
        },
        {
          "arcs": [[-35, -310, -303, 519, -350]],
          "type": "Polygon",
          "properties": { "name": "Slovenia", "Alpha-2": "SI" },
          "id": "SVN"
        },
        {
          "arcs": [[-446, -252, 520]],
          "type": "Polygon",
          "properties": { "name": "Sweden", "Alpha-2": "SE" },
          "id": "SWE"
        },
        {
          "arcs": [[521, -422]],
          "type": "Polygon",
          "properties": { "name": "Swaziland", "Alpha-2": "SZ" },
          "id": "SWZ"
        },
        {
          "arcs": [[-352, -347, -386, 522, 523, -339]],
          "type": "Polygon",
          "properties": { "name": "Syria", "Alpha-2": "SY" },
          "id": "SYR"
        },
        {
          "arcs": [[-440, -393, -504, -115, -176]],
          "type": "Polygon",
          "properties": { "name": "Chad", "Alpha-2": "TD" },
          "id": "TCD"
        },
        {
          "arcs": [[524, -269, -64, -57]],
          "type": "Polygon",
          "properties": { "name": "Togo", "Alpha-2": "TG" },
          "id": "TGO"
        },
        {
          "arcs": [[525, -433, 526, -415, -382, -371]],
          "type": "Polygon",
          "properties": { "name": "Thailand", "Alpha-2": "TH" },
          "id": "THA"
        },
        {
          "arcs": [[-369, -160, 527, 528]],
          "type": "Polygon",
          "properties": { "name": "Tajikistan", "Alpha-2": "TJ" },
          "id": "TJK"
        },
        {
          "arcs": [[-328, 529, -360, 530, 531]],
          "type": "Polygon",
          "properties": { "name": "Turkmenistan", "Alpha-2": "TM" },
          "id": "TKM"
        },
        {
          "arcs": [[532, -311]],
          "type": "Polygon",
          "properties": { "name": "East Timor", "Alpha-2": "TL" },
          "id": "TLS"
        },
        { "type": null, "properties": { "name": "Trinidad and Tobago", "Alpha-2": "TT" }, "id": "TTO" },
        {
          "arcs": [[-225, 533, -390]],
          "type": "Polygon",
          "properties": { "name": "Tunisia", "Alpha-2": "TN" },
          "id": "TUN"
        },
        {
          "arcs": [[[-267, -30, -333, -340, -524, 534]], [[-283, -71, 535]]],
          "type": "MultiPolygon",
          "properties": { "name": "Turkey", "Alpha-2": "TR" },
          "id": "TUR"
        },
        { "arcs": [[536]], "type": "Polygon", "properties": { "name": "Taiwan", "Alpha-2": "TW" }, "id": "TWN" },
        {
          "arcs": [[-365, 537, -419, -431, 538, -180, -49, -495, 539]],
          "type": "Polygon",
          "properties": { "name": "United Republic of Tanzania", "Alpha-2": "TZ" },
          "id": "TZA"
        },
        {
          "arcs": [[-496, -178, -185, -508, -366, -540]],
          "type": "Polygon",
          "properties": { "name": "Uganda", "Alpha-2": "UG" },
          "id": "UGA"
        },
        {
          "arcs": [[-490, 540, -480, -404, -479, -307, -519, -471, -81]],
          "type": "Polygon",
          "properties": { "name": "Ukraine", "Alpha-2": "UA" },
          "id": "UKR"
        },
        {
          "arcs": [[-106, 541, -22]],
          "type": "Polygon",
          "properties": { "name": "Uruguay", "Alpha-2": "UY" },
          "id": "URY"
        },
        {
          "arcs": [[[542, -408, 543, -126]], [[-128, 544]]],
          "type": "MultiPolygon",
          "properties": { "name": "United States of America", "Alpha-2": "US" },
          "id": "USA"
        },
        {
          "arcs": [[-531, -359, -370, -529, 545]],
          "type": "Polygon",
          "properties": { "name": "Uzbekistan", "Alpha-2": "UZ" },
          "id": "UZB"
        },
        {
          "arcs": [[546, -295, -101, -192]],
          "type": "Polygon",
          "properties": { "name": "Venezuela", "Alpha-2": "VE" },
          "id": "VEN"
        },
        {
          "arcs": [[547, -373, -384, -151]],
          "type": "Polygon",
          "properties": { "name": "Vietnam", "Alpha-2": "VN" },
          "id": "VNM"
        },
        { "type": null, "properties": { "name": "Vanuatu", "Alpha-2": "VU" }, "id": "VUT" },
        {
          "arcs": [[-355, -343]],
          "type": "Polygon",
          "properties": { "name": "West Bank", "Alpha-2": "PS" },
          "id": "PSE"
        },
        {
          "arcs": [[548, -501, -453]],
          "type": "Polygon",
          "properties": { "name": "Yemen", "Alpha-2": "YE" },
          "id": "YEM"
        },
        {
          "arcs": [[-438, -111, 549, -423, -522, -421, 550], [-395]],
          "type": "Polygon",
          "properties": { "name": "South Africa", "Alpha-2": "ZA" },
          "id": "ZAF"
        },
        {
          "arcs": [[-430, -425, 551, -113, -437, -1, -181, -539]],
          "type": "Polygon",
          "properties": { "name": "Zambia", "Alpha-2": "ZM" },
          "id": "ZMB"
        },
        {
          "arcs": [[-550, -114, -552, -424]],
          "type": "Polygon",
          "properties": { "name": "Zimbabwe", "Alpha-2": "ZW" },
          "id": "ZWE"
        }
      ]
    }
  }
}
